<template>
  <div class="housing-manage">
    <breadcrumb :breadcrumb="breadcrumb" />
    <div class="page-content">

      <div class="page-content-top-statistics-data">
        <div class="page-content-top-statistics-data-title-line">
          <div class="page-content-top-statistics-data-title-tip"></div>
          <div class="page-content-top-statistics-data-title">园区房产总计</div>
        </div>
        <div class="page-content-top-statistics-data-line">
          <div class="page-content-top-statistics-data-line-item">
            <p class="page-content-top-statistics-data-line-num">{{allBuildingData.buildingCount || 0}}</p>
            <p class="page-content-top-statistics-data-line-tip">总楼数</p>
          </div>
          <div class="page-content-top-statistics-data-line-item-division"></div>
          <div class="page-content-top-statistics-data-line-item">
            <p class="page-content-top-statistics-data-line-num">{{allBuildingData.roomCount || 0}} <span class="page-content-top-statistics-data-line-tip">间</span></p>
            <p class="page-content-top-statistics-data-line-tip">总房间</p>
          </div>
          <div class="page-content-top-statistics-data-line-item-division"></div>
          <div class="page-content-top-statistics-data-line-item">
            <p class="page-content-top-statistics-data-line-num">{{allBuildingData.avgRent || 0}} <span class="page-content-top-statistics-data-line-tip">元 / 间</span></p>
            <div class="page-content-top-statistics-data-line-tip">在租均价
              <el-tooltip class="item" effect="dark" placement="bottom">
                <div slot="content">当天的租金总和/当天的租售房间总和</div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
          </div>
          <div class="page-content-top-statistics-data-line-item-division"></div>
          <div class="page-content-top-statistics-data-line-item">
            <p class="page-content-top-statistics-data-line-num">{{allBuildingData.leaseroomCount}} <span class="page-content-top-statistics-data-line-tip">间</span></p>
            <p class="page-content-top-statistics-data-line-tip">已租房间: {{allBuildingData.leaseroomCountPercent}}</p>
          </div>
          <div class="page-content-top-statistics-data-line-item-division"></div>
          <div class="page-content-top-statistics-data-line-item">
            <p class="page-content-top-statistics-data-line-num">{{allBuildingData.unleaseroomCount}} <span class="page-content-top-statistics-data-line-tip">间</span></p>
            <p class="page-content-top-statistics-data-line-tip">未租房间: {{allBuildingData.unleaseroomCountPercent}}</p>
          </div>
          <div class="page-content-top-statistics-data-line-item-division"></div>
          <div class="page-content-top-statistics-data-line-item">
            <p class="page-content-top-statistics-data-line-num">{{allBuildingData.totalPeople || '0'}}</p>
            <p class="page-content-top-statistics-data-line-tip">住户总数</p>
          </div>
          <div class="page-content-top-statistics-data-line-item-division"></div>
          <div class="page-content-top-statistics-data-line-item">
            <p class="page-content-top-statistics-data-line-num">{{allBuildingData.rentRate || 0}}</p>
            <div class="page-content-top-statistics-data-line-tip">满租率
              <el-tooltip class="item" effect="dark" placement="bottom">
                <div slot="content">∑合同出租房间/总可租房间(按月统计)</div>
                <i class="el-icon-question"></i>
              </el-tooltip>
            </div>
          </div>
        </div>
      </div>

      <div class="page-main">
        <div class="housing-left">
          <div class="housing-top-title-line">
            <div class="housing-top-title-tip"></div>
            <div class="housing-top-title-main">房产</div>
            <button-add :pathName="addHouseBuildingName" v-if="permissionCodes.indexOf('001003007') !== -1" value="新建楼栋"/>
          </div>
          <div v-for="build in buildingList" :class="currentBuildingData.code === build.code ? 'build-item-current' : 'build-item'" @click="changeTheBuildingData(build)">
            <div class="build-item-name"><span>{{build.name}}</span> </div>
            <div class="build-item-floor"><span>{{build.totalArea}}m²</span><span>{{build.startFloor}}~{{build.endFloor}}层</span></div>
          </div>
        </div>

        <transition enter-active-class="animate__animated animate__fadeInRight" leave-active-class="animate__animated animate__fadeOutRight" :duration="{enter:1000,leave:300}">
          <div class="housing-right" v-show="showHousingRightBox">
            <!--楼栋统计数-->
            <div class="housing-right-top">
              <div class="housing-right-top-name">
                <div class="housing-right-top-name-left">
                  <i class="el-icon-damai-ic_loudong housing-right-top-name-left-icon"></i>
                  <div class="housing-right-top-name-left-info">{{ currentBuildingData.name }}</div>
                </div>
                <div class="housing-right-top-name-right">
                  <button-add :pathName="addHouseRouterName" :value="addBtnValue" v-if="permissionCodes.indexOf('001003001') !== -1"/>
                  <button-cancel style="margin-left: 10px;" @cancel="goToModifyBuildingPage(currentBuildingData.code)" value="修改楼栋" v-if="permissionCodes.indexOf('001003009') !== -1" />
                  <button-delete style="margin: 0 0 0 10px;" iconClassName="" v-if="permissionCodes.indexOf('001003011') !== -1" value="删除楼栋" @click="deleteBuild(currentBuildingData.code)" />
<!--                  <button-cancel style="margin: 0 0 0 10px;" value="按比例查看" v-if="roomShowType === 'routine'" @cancel="toShowProportion" />-->
<!--                  <button-cancel style="margin: 0 0 0 10px;" value="常规查看" v-if="roomShowType === 'proportion'" @cancel="toShowRoutine" />-->
                  <button-upload :cathUrl="uploadUrl" :onSuccess="uploadSuccess" @getpage="refreshData" value="导入" v-if="permissionCodes.indexOf('001003004') !== -1"/>
                  <button-export :href="exportUrl" :beforeDownload="beforeDownload" download="download.xls" value="导出" v-if="permissionCodes.indexOf('001003005') !== -1"/>
                </div>
              </div>
              <div class="housing-right-top-division"></div>
              <div class="housing-right-top-main-line">
                <div class="housing-right-top-main-line-item">
                  <p class="housing-right-top-main-line-num">{{currentBuildingData.totalArea || 0}} <span class="housing-right-top-main-line-tip">m²</span></p>
                  <p class="housing-right-top-main-line-tip">总面积</p>
                </div>
                <div class="housing-right-top-main-line-item">
                  <p class="housing-right-top-main-line-num">{{currentBuildingData.roomCount || 0}} <span class="housing-right-top-main-line-tip">间</span></p>
                  <p class="housing-right-top-main-line-tip">房间数</p>
                </div>
                <div class="housing-right-top-main-line-item">
                  <p class="housing-right-top-main-line-num">{{currentBuildingData.avgPrice || 0}} <span class="housing-right-top-main-line-tip">元 / m² / 天</span></p>
                  <div class="housing-right-top-main-line-tip">在租均价
                    <el-tooltip class="item" effect="dark" placement="bottom">
                      <div slot="content">当前楼栋当天的租金总和/当前楼栋当天的租售面积总和</div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </div>
                </div>
                <div class="housing-right-top-main-line-item">
                  <p class="housing-right-top-main-line-num">{{currentBuildingData.leaseroomCount || 0}} <span class="housing-right-top-main-line-tip">间</span></p>
                  <p class="housing-right-top-main-line-tip">已租房间: {{ currentBuildingData.leaseroomCountPercent }}</p>
                </div>
                <div class="housing-right-top-main-line-item">
                  <p class="housing-right-top-main-line-num">{{currentBuildingData.unleaseroomCount || 0}} <span class="housing-right-top-main-line-tip">间</span></p>
                  <p class="housing-right-top-main-line-tip">未租房间: {{ currentBuildingData.unleaseroomCountPercent }}</p>
                </div>
                <div class="housing-right-top-main-line-item">
                  <p class="housing-right-top-main-line-num">{{currentBuildingData.enterpriseCount || '0'}}</p>
                  <p class="housing-right-top-main-line-tip">入驻住户数量</p>
                </div>
                <div class="housing-right-top-main-line-item">
                  <p class="housing-right-top-main-line-num">{{currentBuildingData.rentAreaPercent || '0'}}</p>
                  <div class="housing-right-top-main-line-tip">出租率
                    <el-tooltip class="item" effect="dark" placement="bottom">
                      <div slot="content">已租面积/总可租面积</div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>

            <div class="housing-right-main">
              <div class="housing-right-main-select-level1-line">
                <div class="housing-right-main-select-level1">
                  <div class="housing-right-main-select-level1-title">房间类型：</div>
                  <div :class="[currentRoomShowOnPageTypeStatus === 'all' ? 'housing-right-main-select-level1-item-current' : 'housing-right-main-select-level1-item']" @click="changeCurrentRoomShowOnPageTypeStatus('all')">全部</div>
                  <div :class="[currentRoomShowOnPageTypeStatus === '12' ? 'housing-right-main-select-level1-item-current' : 'housing-right-main-select-level1-item']" @click="changeCurrentRoomShowOnPageTypeStatus('12')">出租({{leaseDataLength}})</div>
                  <div :class="[currentRoomShowOnPageTypeStatus === '10' ? 'housing-right-main-select-level1-item-current' : 'housing-right-main-select-level1-item']" @click="changeCurrentRoomShowOnPageTypeStatus('10')">公用({{publicUseDataLength}})</div>
                  <div :class="[currentRoomShowOnPageTypeStatus === '11' ? 'housing-right-main-select-level1-item-current' : 'housing-right-main-select-level1-item']" @click="changeCurrentRoomShowOnPageTypeStatus('11')">自用({{selfUseDataLength}})</div>
                </div>
              </div>
              <div class="building-right-select" v-if="currentRoomShowOnPageTypeStatus === '12'">
                <div class="building-right-select-info">
                  <div class="building-right-select-item" @click="changeCurrentRoomShowOnPageStatus('all')">
                    <span :style="{'color': currentRoomShowOnPageStatus === 'all' ? '#1362FF' : '#333333'}">全部</span>
                  </div>
                  <div class="building-right-select-item" @click="changeCurrentRoomShowOnPageStatus('1')">
                    <i class="el-icon-damai-fangjian" style="color: #18887B;margin-right: 2px;"></i>
                    <span :style="{'color': currentRoomShowOnPageStatus === '1' ? '#18887B' : '#333333'}">正常在租({{tabNormalDataLength}})</span>
                  </div>
                  <div class="building-right-select-item" @click="changeCurrentRoomShowOnPageStatus('0')" style="border-right: none">
                    <i class="el-icon-damai-fangjian" style="color: #9A9A48;margin-right: 2px;"></i>
                    <span :style="{'color': currentRoomShowOnPageStatus === '0' ? '#9A9A48' : '#333333'}">空置({{tabVacantDataLength}})</span>
                  </div>
                  <div class="building-right-select-item" @click="changeCurrentRoomShowOnPageStatus('9')">
                    <i class="el-icon-damai-fangjian" style="color: #FC5A5A;margin-right: 2px;"></i>
                    <span :style="{'color': currentRoomShowOnPageStatus === '9' ? '#FC5A5A' : '#333333'}">已逾期({{tabNearData_negativeLength}})</span>
                  </div>
                  <div class="building-right-select-item" @click="changeCurrentRoomShowOnPageStatus('5')">
                    <i class="el-icon-damai-fangjian" style="color: #E56000;margin-right: 2px;"></i>
                    <span :style="{'color': currentRoomShowOnPageStatus === '5' ? '#E56000' : '#333333'}">30天内到期({{tabNearData_30Length}})</span>
                  </div>
                  <div class="building-right-select-item" @click="changeCurrentRoomShowOnPageStatus('6')">
                    <i class="el-icon-damai-fangjian" style="color: #F29324;margin-right: 2px;"></i>
                    <span :style="{'color': currentRoomShowOnPageStatus === '6' ? '#F29324' : '#333333'}">90天内到期({{tabNearData_90Length}})</span>
                  </div>
                  <div class="building-right-select-item" @click="changeCurrentRoomShowOnPageStatus('7')">
                    <i class="el-icon-damai-fangjian" style="color: #5E41FE;margin-right: 2px;"></i>
                    <span :style="{'color': currentRoomShowOnPageStatus === '7' ? '#5E41FE' : '#333333'}">180天内到期({{tabNearData_180Length}})</span>
                  </div>
                  <div class="building-right-select-item" @click="changeCurrentRoomShowOnPageStatus('8')">
                    <i class="el-icon-damai-fangjian" style="color: #8B36EF;margin-right: 2px;"></i>
                    <span :style="{'color': currentRoomShowOnPageStatus === '8' ? '#8B36EF' : '#333333'}">未租满({{tabNotRentFullDataLength}})</span>
                  </div>
                  <div class="building-right-select-item" @click="changeCurrentRoomShowOnPageStatus('2')">
                    <i class="el-icon-damai-fangjian" style="color: #364BA2;margin-right: 2px;"></i>
                    <span :style="{'color': currentRoomShowOnPageStatus === '2' ? '#364BA2' : '#333333'}">待签订({{tabSignDataLength}})</span>
                  </div>
                  <div class="building-right-select-item" @click="changeCurrentRoomShowOnPageStatus('4')">
                    <i class="el-icon-damai-fangjian" style="color: #50B5FF;margin-right: 2px;"></i>
                    <span :style="{'color': currentRoomShowOnPageStatus === '4' ? '#50B5FF' : '#333333'}">已预定({{tabScheduledDataLength}})</span>
                  </div>
                </div>
              </div>
              <div class="building-right-room-box">
                <div v-for="(build, buildIndex) in tabAllData" class="building-right-room-box-floor">
                  <div class="building-right-floor-title">
                    <el-tooltip effect="dark" content="点击查看楼层详情" placement="right">
                      <span>
                        <span @click="showCurrentFloorDisplayDrawer(build)" style="cursor: pointer">{{build.floor.name}}层</span>
                        <span @click="showCurrentFloorDisplayDrawer(build)" class="building-right-floor-subtitle" style="cursor: pointer">({{build.floor.area}} m²)</span>
                      </span>
                    </el-tooltip>
                  </div>

                  <transition name="el-zoom-in-center" >
                    <div class="building-right-room-proportion-line" v-show="roomShowType === 'proportion'" >

                      <div @click="housingBoxClick(room)" v-for="room in build.rooms" :key="room.code" class="building-right-room-proportion-line-item" v-show="currentRoomShowOnPageTypeStatus === 'all' || (currentRoomShowOnPageTypeStatus === room.type && (currentRoomShowOnPageStatus === room.rentStatus || currentRoomShowOnPageStatus === 'all'))" :style="{backgroundColor: (room.rentStatus === '0' ? '#F8F8E2': (room.rentStatus === '1' ? '#E3F0EE': (room.rentStatus === '2' ? '#CCD2EB': (room.rentStatus === '4' ? '#EAF5FF': (room.rentStatus === '5' ? '#F5EBE4': (room.rentStatus === '6' ? '#FDF3E7': (room.rentStatus === '7' ? '#F0EDFD': (room.rentStatus === '8' ? '#F1E8FC': (room.rentStatus === '9' ? '#FAECEC': (room.rentStatus === '10' ? '#D8EDF0': (room.rentStatus === '11' ? '#E7F4E2': '#ccccccaa'))))))))))), width: room.widthOnPageByProportion}">

                        <el-popover placement="top" trigger="hover" popper-class="building-right-room-proportion-popover-box">
                          <div class="building-right-room-proportion-popover-name">{{room.enterpriseName || '无'}} <span class="building-right-room-proportion-popover-name-tip" :style="{color: (room.rentStatus === '0' ? '#9A9A48': (room.rentStatus === '1' ? '#18887B': (room.rentStatus === '2' ? '#364BA2': (room.rentStatus === '4' ? '#50B5FF': (room.rentStatus === '5' ? '#E56000': (room.rentStatus === '6' ? '#F29324': (room.rentStatus === '7' ? '#5E41FE': (room.rentStatus === '8' ? '#8B36EF': (room.rentStatus === '9' ? '#FC5A5A': (room.rentStatus === '10' ? '#1FB6CB': (room.rentStatus === '11' ? '#5A844A': '#cccccc'))))))))))), backgroundColor: (room.rentStatus === '0' ? '#F8F8E2': (room.rentStatus === '1' ? '#E3F0EE': (room.rentStatus === '2' ? '#CCD2EB': (room.rentStatus === '4' ? '#EAF5FF': (room.rentStatus === '5' ? '#F5EBE4': (room.rentStatus === '6' ? '#FDF3E7': (room.rentStatus === '7' ? '#F0EDFD': (room.rentStatus === '8' ? '#F1E8FC': (room.rentStatus === '9' ? '#FAECEC': (room.rentStatus === '10' ? '#D8EDF0': (room.rentStatus === '11' ? '#E7F4E2': '#ccccccaa')))))))))))}">{{room.rentStatus === '0' ? '空置': (room.rentStatus === '1' ? '正常在租': (room.rentStatus === '2' ? '待签订': (room.rentStatus === '4' ? '已预定': (room.rentStatus === '5' ? '30天内到期': (room.rentStatus === '6' ? '90天内到期': (room.rentStatus === '7' ? '180天内到期': (room.rentStatus === '8' ? '未租满': (room.rentStatus === '9' ? '已逾期': (room.rentStatus === '10' ? '公用': (room.rentStatus === '11' ? '自用': '暂未分配'))))))))))}}</span></div>
                          <div class="building-right-room-proportion-popover-info">房间号：{{room.roomNumber}}({{room.roomArea}}m²)</div>
                          <div class="building-right-room-proportion-popover-info">到期日：{{room.leaseStopTime || '暂无'}}</div>
                          <div class="building-right-room-proportion-popover-btn-line">
                            <el-tooltip content="查看" placement="bottom">
                              <i class="el-icon-damai-ic_chakan" @click="showRoomDialog(room)"></i>
                            </el-tooltip>
                            <el-tooltip content="修改" placement="bottom">
                              <i class="el-icon-damai-bianji" @click="toModifyPage(room.code)" v-if="permissionCodes.indexOf('001003003') !== -1"></i>
                            </el-tooltip>
                            <el-tooltip content="删除" placement="bottom">
                              <i class="el-icon-damai-ic_shanchu1" @click="deleteItem(room.code, room.rentStatus)" v-if="permissionCodes.indexOf('001003002') !== -1"></i>
                            </el-tooltip>
                          </div>

                          <div slot="reference" class="building-right-room-proportion-info" >
                            <div class="building-right-room-proportion-popover-frame" :style="{backgroundColor: (room.rentStatus === '0' ? '#9A9A48': (room.rentStatus === '1' ? '#18887B': (room.rentStatus === '2' ? '#364BA2': (room.rentStatus === '4' ? '#50B5FF': (room.rentStatus === '5' ? '#E56000': (room.rentStatus === '6' ? '#F29324': (room.rentStatus === '7' ? '#5E41FE': (room.rentStatus === '8' ? '#8B36EF': (room.rentStatus === '9' ? '#FC5A5A': (room.rentStatus === '10' ? '#1FB6CB': (room.rentStatus === '11' ? '#5A844A': '#cccccc')))))))))))}"></div>
                            <div class="building-right-room-proportion-name">{{room.enterpriseName || '无'}}</div>
                            <div class="building-right-room-proportion-owner">房间：{{room.roomNumber}} / {{room.roomArea}}m² <span style="display: inline-block" v-if="room.officeSeat"> / {{room.officeSeat}}工位</span></div>
                            <div class="building-right-room-proportion-owner">到期日：{{room.contractEndDate || '暂无'}}</div>
                          </div>
                        </el-popover>
                      </div>
                    </div>
                  </transition>


                  <transition name="el-zoom-in-center">
                    <div class="building-right-room-line" v-show="roomShowType === 'routine'" v-for="room in build.rooms" :key="room.code">
                      <div v-for="room in build.rooms" :key="room.code" class="building-right-room-item" v-show="currentRoomShowOnPageTypeStatus === 'all' || (currentRoomShowOnPageTypeStatus === room.type && (currentRoomShowOnPageStatus === room.rentStatus || currentRoomShowOnPageStatus === 'all'))" >
                        <el-popover placement="bottom" trigger="hover" :visible-arrow="false" popper-class="housing-popover-box">
                          <div class="building-right-room-item-operation">
                            <el-tooltip content="查看" placement="bottom">
                              <div class="building-right-room-item-operation-bg-box" @click="showRoomDialog(room)">
                                <i class="el-icon-damai-ic_chakan"></i>
                              </div>
                            </el-tooltip>

                            <el-tooltip content="修改" placement="bottom">
                              <div class="building-right-room-item-operation-bg-box" @click="toModifyPage(room.code)" v-if="permissionCodes.indexOf('001003003') !== -1">
                                <i class="el-icon-damai-bianji"></i>
                              </div>
                            </el-tooltip>

                            <el-tooltip content="删除" placement="bottom">
                              <div class="building-right-room-item-operation-bg-box" @click="deleteItem(room.code, room.rentStatus)" v-if="permissionCodes.indexOf('001003002') !== -1">
                                <i class="el-icon-damai-ic_shanchu1"></i>
                              </div>
                            </el-tooltip>
                          </div>
                          <div class="building-right-room-item" slot="reference" @click="housingBoxClick(room)" :style="{backgroundColor: (room.rentStatus === '0' ? '#F8F8E2': (room.rentStatus === '1' ? '#E3F0EE': (room.rentStatus === '2' ? '#CCD2EB': (room.rentStatus === '4' ? '#EAF5FF': (room.rentStatus === '5' ? '#F5EBE4': (room.rentStatus === '6' ? '#FDF3E7': (room.rentStatus === '7' ? '#F0EDFD': (room.rentStatus === '8' ? '#F1E8FC': (room.rentStatus === '9' ? '#FAECEC': (room.rentStatus === '10' ? '#D8EDF0': (room.rentStatus === '11' ? '#E7F4E2': '#ccccccaa')))))))))))}">
                            <div class="building-right-room-item-label" :style="{backgroundColor: (room.rentStatus === '0' ? '#9A9A48': (room.rentStatus === '1' ? '#18887B': (room.rentStatus === '2' ? '#364BA2': (room.rentStatus === '4' ? '#50B5FF': (room.rentStatus === '5' ? '#E56000': (room.rentStatus === '6' ? '#F29324': (room.rentStatus === '7' ? '#5E41FE': (room.rentStatus === '8' ? '#8B36EF': (room.rentStatus === '9' ? '#FC5A5A': (room.rentStatus === '10' ? '#1FB6CB': (room.rentStatus === '11' ? '#5A844A': '#cccccc')))))))))))}">
                              <i class="el-icon-damai-fangjian" style="margin-right: 2px;"></i>
                              <span>{{room.rentStatus === '0' ? '空置': (room.rentStatus === '1' ? '正常在租': (room.rentStatus === '2' ? '待签订': (room.rentStatus === '4' ? '已预定': (room.rentStatus === '5' ? '30天内到期': (room.rentStatus === '6' ? '90天内到期': (room.rentStatus === '7' ? '180天内到期': (room.rentStatus === '8' ? '未租满': (room.rentStatus === '9' ? '已逾期': (room.rentStatus === '10' ? '公用': (room.rentStatus === '11' ? '自用': '暂未分配'))))))))))}}</span>
                            </div>
                            <div class="building-right-room-info" >
                              <div class="building-right-room-bed-box">
                                <div class="building-right-room-bed-box-item" v-for="bed in room.beds">
                                  <el-popover placement="top" width="200" trigger="hover">
                                    <div>床位: {{bed.bedsNumber}}</div>
                                    <div>入住人: {{bed.leaseName || '无'}}</div>
                                    <div>到期日: {{bed.leaseStopTime || '暂无'}}</div>
                                    <i class="el-icon-damai-ic_chuangwei" slot="reference" :style="{color: (bed.status === '0' ? '#9A9A48': (bed.status === '1' ? '#18887B': (bed.status === '2' ? '#364BA2': (bed.status === '4' ? '#50B5FF': (bed.status === '5' ? '#E56000': (bed.status === '6' ? '#F29324': (bed.status === '7' ? '#5E41FE': (bed.status === '8' ? '#8B36EF': (bed.status === '9' ? '#FC5A5A': (bed.status === '10' ? '#1FB6CB': (bed.status === '11' ? '#5A844A': '#cccccc')))))))))))}"></i>
                                  </el-popover>
                                </div>
                              </div>
                              <div class="building-right-room-name">{{room.enterpriseName || '无'}}</div>
                              <div class="building-right-room-owner">房间：{{room.roomNumber}}/{{room.roomType || '--'}}/{{room.roomArea}}m²</div>
                              <div class="building-right-room-owner">入住人数：{{ room.stayNum }}</div>
                              <div class="building-right-room-owner">到期日：{{room.leaseStopTime || '暂无'}}</div>
                            </div>
                          </div>
                        </el-popover>
                      </div>
                    </div>
                  </transition>


                </div>
              </div>
            </div>
          </div>
        </transition>

      </div>


    </div>

    <el-dialog title="楼层面积修改" :visible.sync="changeFloorAreaVisible" width="500px">
      <el-form style="width: 360px;margin: 0 auto;">
        <el-form-item label="当前楼层面积" :label-width="dialogInputWidth">
          <el-input v-model="currentFloorArea" autocomplete="off" size="small" style="width: 220px;" disabled>
            <template slot="append">m²</template>
          </el-input>
        </el-form-item>
        <el-form-item label="楼层新面积" :label-width="dialogInputWidth">
          <el-input v-model="newFloorArea" autocomplete="off" size="small" style="width: 220px;">
            <template slot="append">m²</template>
          </el-input>
        </el-form-item>
        <el-form-item label="楼层长度" :label-width="dialogInputWidth">
          <el-input v-model="currentFloorLength" autocomplete="off" size="small" style="width: 220px;">
            <template slot="append">m</template>
          </el-input>
        </el-form-item>
        <el-form-item label="楼层宽度" :label-width="dialogInputWidth">
          <el-input v-model="currentFloorWidth" autocomplete="off" size="small" style="width: 220px;">
            <template slot="append">m</template>
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="changeFloorAreaVisible = false" size="small">取 消</el-button>
        <el-button type="primary" @click="changeFloorArea" size="small">确 定</el-button>
      </div>
    </el-dialog>

    <!--<el-dialog title="楼层面积修改" :visible.sync="changeFloorAreaVisible" width="500px">-->
    <!--<el-form style="width: 360px;margin: 0 auto;">-->
    <!--<el-form-item label="当前楼层面积" :label-width="dialogInputWidth">-->
    <!--<el-input v-model="currentFloorArea" autocomplete="off" size="small" style="width: 220px;" disabled />-->
    <!--</el-form-item>-->
    <!--<el-form-item label="楼层新面积" :label-width="dialogInputWidth">-->
    <!--<el-input v-model="newFloorArea" autocomplete="off" size="small" style="width: 220px;" />-->
    <!--</el-form-item>-->
    <!--</el-form>-->
    <!--<div class="form-btn-box">-->
    <!--<button-confirm @confirm="confirm" />-->
    <!--<button-cancel @cancel="cancel" />-->
    <!--</div>-->
    <!--</el-dialog>-->

    <div>
      <transition name="right-slide">
        <div class="window-left-box" v-show="windowLeftBox">
          <div class="window-left-main">
            <div style="text-align: left;font-size: 22px;font-weight: 600;">{{windowLeftInfo.buildingName}} / {{+windowLeftInfo.floorName}}层 / {{windowLeftInfo.roomNumber}}</div>
            <div style="display: flex;justify-content: space-between;margin: 10px 0;">
              <div style="width: 25%">
                <div>面积(m²)</div>
                <div>{{windowLeftInfo.roomArea}}</div>
              </div>
              <div style="width: 25%">
                <div>住户</div>
                <div>{{windowLeftInfo.enterpriseName}}</div>
              </div>
              <div style="width: 25%">
                <div>预租单价(元 / m²·天)</div>
                <div>{{windowLeftInfo.roomRent}}</div>
              </div>
            </div>
            <div>
              <table-main :selection="false" :tableHead="contractTableHead" :tableData="contractList" :total="windowLeftTotal" :pageNum="windowLeftPageNum" :pageSize="windowLeftPageSize" :hasOperation="false" @changePagination="changeWindowLeftPagination" :row-click="windowLeftRowClick" />
            </div>
          </div>
          <div class="mask" @click.capture.stop="windowLeftBox = !windowLeftBox"></div>
        </div>
      </transition>
    </div>

    <el-drawer
      :with-header="false"
      :visible.sync="drawer"
      size="70%"
      :before-close="handleClose">
      <div class="contract-detail-on-housing">
        <button @click="contractDataToWindowLeft" class="el-icon-back"></button>
        <form>
          <div class="form-title">住户信息</div>
          <div class="form-line">
            <div>
              <div class="line-text">住户名称：</div>
              <div class="line-info">{{formData.leaseName || '无'}}</div>
            </div>
            <div>
              <div class="line-text">签订人：</div>
              <div class="line-info">{{formData.signerName || '无'}}</div>
            </div>
            <div>
              <div class="line-text">签订人手机：</div>
              <div class="line-info">{{formData.signerPhone || '无'}}</div>
            </div>
          </div>

          <div class="form-title">房源信息</div>
          <div class="form-line" v-for="(roomItem, roomIndex) in formData.roomList" :key="roomIndex">
            <div>
              <div class="line-text">房间号：</div>
              <div class="line-info">{{roomItem._label || '无'}}</div>
            </div>
            <div v-if="formData.rentType == 1">
              <div class="line-text">床位号：</div>
              <div class="line-info">{{roomItem._bedsLabel || '无'}}</div>
            </div>
          </div>

          <div class="form-title" style="display: flex;justify-content: space-between;">
            <span>合同信息</span>
            <span style="margin-left: 20px;color: #00A0E6;cursor: pointer;" @click="dialogFormVisible = true"><i class="el-icon-damai-jiaofeijilu"></i>查看明细</span>
          </div>
          <div class="form-line discount-line">
            <div>
              <div class="line-text">合同开始时间：</div>
              <div class="line-info">{{formData.contractStartDate || '无'}}</div>
            </div>
            <div>
              <div class="line-text">合同结束时间：</div>
              <div class="line-info">{{formData.contractEndDate || '无'}}</div>
            </div>
            <div>
              <div class="line-text">合同签订时间：</div>
              <div class="line-info">{{formData.contractSignDate || '无'}}</div>
            </div>
          </div>
          <el-tabs type="border-card" style="box-shadow: none;margin-top: 10px;">
            <el-tab-pane label="租金条款">
              <div style="height: 300px;overflow-y: auto;">
                <div class="form-title" style="border-left: 3px solid #ffffff;">保证金信息</div>
                <div class="form-line">
                  <div>
                    <div class="line-text">保证金金额：</div>
                    <div class="line-info" v-if="formData.leasePledge">{{formData.leasePledge}}元</div>
                    <div class="line-info" v-if="!formData.leasePledge">无</div>
                  </div>
                  <div>
                    <div class="line-text">币种：</div>
                    <div class="line-info">人民币CNY</div>
                  </div>
                </div>

                <div class="form-title" style="border-left: 3px solid #ffffff;">租金信息</div>
                <div v-for="(contractManagerLeaseItem, index) in formData.contractManagerLeaseItems" :key="index" style="padding: 20px 0 10px;margin: 0 5px 20px 0;border: 1px solid #eeeeee;position: relative;border-radius: 3px;">
                  <div class="form-line discount-line">
                    <div>
                      <div class="line-text">开始时间：</div>
                      <div class="line-info">{{contractManagerLeaseItem.leaseContractStartDate || '无'}}</div>
                    </div>
                    <div>
                      <div class="line-text">结束时间：</div>
                      <div class="line-info">{{contractManagerLeaseItem.leaseContractEndDate || '无'}}</div>
                    </div>
                    <div>
                      <div class="line-text">合同单价：</div>
                      <div class="line-info" v-if="contractManagerLeaseItem.leaseContractPer">
                        {{contractManagerLeaseItem.leaseContractPer}}
                        <span v-if="contractManagerLeaseItem.leaseContractPerUnit === '1'">元 / 间 / 月</span>
                        <span v-if="contractManagerLeaseItem.leaseContractPerUnit === '2'">元 / 间 / 天</span>
                        <span v-if="contractManagerLeaseItem.leaseContractPerUnit === '3'">元 / 床 / 月</span>
                        <span v-if="contractManagerLeaseItem.leaseContractPerUnit === '4'">元 / 床 / 天</span>
                      </div>
                      <div class="line-info" v-else>无</div>
                    </div>
                  </div>
                  <div class="form-line discount-line">
                    <div>
                      <div class="line-text">提前付款天数：</div>
                      <div class="line-info" v-if="contractManagerLeaseItem.leaseAheadPayDays">{{contractManagerLeaseItem.leaseAheadPayDays}}自然日</div>
                      <div class="line-info" v-else>无</div>
                    </div>
                    <div>
                      <div class="line-text">租期划分方式：</div>
                      <div class="line-info" v-if="contractManagerLeaseItem.leaseRentDivideType === '1'">按起始日划分</div>
                      <div class="line-info" v-if="contractManagerLeaseItem.leaseRentDivideType === '2'">按自然月划分（首月非整自然月划入第一期）</div>
                    </div>
                    <div>
                      <div class="line-text">计费类型：</div>
                      <div class="line-info" v-if="contractManagerLeaseItem.leasePayUnitType === '1'">按实际天数计费</div>
                      <div class="line-info" v-if="contractManagerLeaseItem.leasePayUnitType === '2'">按月计费</div>
                    </div>
                  </div>
                  <div class="form-line " style="flex-wrap: wrap">
                    <div v-if="contractManagerLeaseItem.leaseContractPerUnit === '2' || contractManagerLeaseItem.leaseContractPerUnit === '3'">
                      <div class="line-text">天单价换算：</div>
                      <div class="line-info" v-if="contractManagerLeaseItem.leasePerDayType === '1'">按自然月换算</div>
                      <div class="line-info" v-if="contractManagerLeaseItem.leasePerDayType === '2'">按年换算</div>
                    </div>
                    <div v-if="contractManagerLeaseItem.leasePayUnitType === '2'">
                      <div class="line-text">年天数：</div>
                      <div class="line-info">365天</div>
                    </div>
                    <div>
                      <div class="line-text">付款周期：</div>
                      <div class="line-info" v-if="contractManagerLeaseItem.leasePayPeriod" >{{contractManagerLeaseItem.leasePayPeriod}}月一付</div>
                      <div class="line-info" v-else >无</div>
                    </div>
                  </div>
                </div>

                <div class="form-title" style="border-left: 3px solid #ffffff;" v-if="formData.contractManagerIncreaseLeases.length > 0">递增率</div>
                <div class="form-line discount-line" v-for="item in formData.contractManagerIncreaseLeases">
                  <div>
                    <div class="line-text">递增时间：</div>
                    <div class="line-info">{{item.leaseIncreaseTimePoint || '无'}}</div>
                  </div>
                  <div>
                    <div class="line-text">单价递增率：</div>
                    <div class="line-info">{{item.leaseIncreasePriceRate}} %</div>
                  </div>
                </div>

                <div class="form-title" style="border-left: 3px solid #ffffff;" v-if="formData.contractManagerDiscountLeases">优惠</div>
                <div class="form-line" v-for="item in formData.contractManagerDiscountLeases">
                  <div>
                    <div class="line-text">免租期：</div>
                    <div class="line-info" style="width: 330px;" v-if="item.startTime && item.endTime">{{item.startTime}} 至 {{item.endTime}}</div>
                    <div class="line-info" v-else>无</div>
                  </div>
                  <div>
                    <div class="line-text">备注：</div>
                    <div class="line-info">{{item.memo || '无'}}</div>
                  </div>
                </div>

                <!--<div class="form-title" style="border-left: 3px solid #ffffff;">优惠</div>-->
                <!--<div class="form-line">-->
                <!--<div>-->
                <!--<div class="line-text">优惠类型：</div>-->
                <!--<div class="line-info" v-if="formData.leaseDiscountType === '1'">免租期</div>-->
                <!--<div class="line-info" v-else>无</div>-->
                <!--</div>-->
                <!--<div>-->
                <!--<div class="line-text">开始时间：</div>-->
                <!--<div class="line-info">{{formData.leaseDiscountStartTime || '无'}}</div>-->
                <!--</div>-->
                <!--<div>-->
                <!--<div class="line-text">结束时间：</div>-->
                <!--<div class="line-info">{{formData.leaseDiscountEndTime || '无'}}</div>-->
                <!--</div>-->
                <!--</div>-->
              </div>
            </el-tab-pane>
            <el-tab-pane label="物业费条款">
              <div style="height: 300px;overflow-y: auto;">
                <div class="form-title" style="border-left: 3px solid #ffffff;">保证金信息</div>
                <div class="form-line">
                  <div>
                    <div class="line-text">保证金金额：</div>
                    <div class="line-info" v-if="formData.propertyPledge">{{formData.propertyPledge}}元</div>
                    <div class="line-info" v-if="!formData.propertyPledge">无</div>
                  </div>
                  <div>
                    <div class="line-text">币种：</div>
                    <div class="line-info">人民币CNY</div>
                  </div>
                </div>

                <div class="form-title" style="border-left: 3px solid #ffffff;">物业费信息</div>
                <div v-for="(contractManagerPropertyItem, index) in formData.contractManagerPropertyItems" :key="index" style="padding: 20px 0 10px;margin: 0 5px 20px 0;border: 1px solid #eeeeee;position: relative;border-radius: 3px;">
                  <div class="form-line discount-line">
                    <div>
                      <div class="line-text">开始时间：</div>
                      <div class="line-info">{{contractManagerPropertyItem.propertyContractStartDate || '无'}}</div>
                    </div>
                    <div>
                      <div class="line-text">结束时间：</div>
                      <div class="line-info">{{contractManagerPropertyItem.propertyContractEndDate || '无'}}</div>
                    </div>
                    <div>
                      <div class="line-text">合同单价：</div>
                      <div class="line-info" v-if="contractManagerPropertyItem.propertyContractPer">
                        {{contractManagerPropertyItem.propertyContractPer}}
                        <span v-if="contractManagerPropertyItem.propertyContractPerUnit === '1'">元 / 间 / 月</span>
                        <span v-if="contractManagerPropertyItem.propertyContractPerUnit === '2'">元 / 间 / 天</span>
                        <span v-if="contractManagerPropertyItem.propertyContractPerUnit === '3'">元 / 床 / 月</span>
                        <span v-if="contractManagerPropertyItem.propertyContractPerUnit === '4'">元 / 床 / 天</span>
                      </div>
                      <div class="line-info" v-else>无</div>
                    </div>
                  </div>
                  <div class="form-line discount-line">
                    <div>
                      <div class="line-text">提前付款天数：</div>
                      <div class="line-info" v-if="contractManagerPropertyItem.propertyAheadPayDays">{{contractManagerPropertyItem.propertyAheadPayDays}}自然日</div>
                      <div class="line-info" v-else>无</div>
                    </div>
                    <div>
                      <div class="line-text">租期划分方式：</div>
                      <div class="line-info" v-if="contractManagerPropertyItem.propertyRentDivideType === '1'">按起始日划分</div>
                      <div class="line-info" v-if="contractManagerPropertyItem.propertyRentDivideType === '2'">按自然月划分（首月非整自然月划入第一期）</div>
                    </div>
                    <div>
                      <div class="line-text">计费类型：</div>
                      <div class="line-info" v-if="contractManagerPropertyItem.propertyPayUnitType === '1'">按实际天数计费</div>
                      <div class="line-info" v-if="contractManagerPropertyItem.propertyPayUnitType === '2'">按月计费</div>
                    </div>
                  </div>
                  <div class="form-line" style="flex-wrap: wrap">
                    <div v-if="contractManagerPropertyItem.propertyContractPerUnit === '2' || contractManagerPropertyItem.propertyContractPerUnit === '3'">
                      <div class="line-text">天单价换算：</div>
                      <div class="line-info" v-if="contractManagerPropertyItem.propertyPerDayType === '1'">按自然月换算</div>
                      <div class="line-info" v-if="contractManagerPropertyItem.propertyPerDayType === '2'">按年换算</div>
                    </div>
                    <div v-if="contractManagerPropertyItem.propertyPayUnitType === '2'">
                      <div class="line-text">年天数：</div>
                      <div class="line-info">{{ contractManagerPropertyItem.daysInYear }}天</div>
                    </div>
                    <div>
                      <div class="line-text">付款周期：</div>
                      <div class="line-info" v-if="contractManagerPropertyItem.propertyPayPeriod" >{{contractManagerPropertyItem.propertyPayPeriod}}月一付</div>
                      <div class="line-info" v-else >无</div>
                    </div>
                  </div>
                </div>

                <div class="form-title" style="border-left: 3px solid #ffffff;" v-if="formData.contractManagerIncreaseProperties.length > 0">递增率</div>
                <div class="form-line discount-line" v-for="item in formData.contractManagerIncreaseProperties">
                  <div>
                    <div class="line-text">递增时间：</div>
                    <div class="line-info">{{item.propertyIncreaseTimePoint || '无'}}</div>
                  </div>
                  <div>
                    <div class="line-text">单价递增率：</div>
                    <div class="line-info">{{item.propertyIncreasePriceRate || '无'}}</div>
                  </div>
                </div>

                <div class="form-title" style="border-left: 3px solid #ffffff;" v-if="formData.contractManagerDiscountProperties.length > 0">优惠</div>
                <div class="form-line" v-for="item in formData.contractManagerDiscountProperties">
                  <div>
                    <div class="line-text">免租期：</div>
                    <div class="line-info" style="width: 330px;" v-if="item.startTime && item.endTime">{{item.startTime}} 至 {{item.endTime}}</div>
                    <div class="line-info" v-else>无</div>
                  </div>
                  <div>
                    <div class="line-text">备注：</div>
                    <div class="line-info">{{item.memo || '无'}}</div>
                  </div>
                </div>

              </div>
            </el-tab-pane>
            <el-tab-pane label="其他条款">
              <div style="height: 300px;overflow-y: auto;">
                <div class="form-title" style="border-left: 3px solid #ffffff;">条款信息</div>
                <div class="form-line" v-for="item in formData.others">
                  <div>
                    <div class="line-text">费用类型：</div>
                    <div class="line-info">{{item.otherItemName || '无'}}</div>
                  </div>
                  <div>
                    <div class="line-text">金额：</div>
                    <div class="line-info" v-if="item.otherItemValue">{{item.otherItemValue}}元</div>
                    <div class="line-info" v-if="!item.otherItemValue">无</div>
                  </div>
                  <div>
                    <div class="line-text">缴费周期：</div>
                    <div class="line-info">{{item.otherItemType === '0' ? '一次性' : (item.otherItemType === '1' ? '按付款周期' : '无')}}</div>
                  </div>
                </div>
              </div>
            </el-tab-pane>
          </el-tabs>

          <div class="form-title" style="margin-top: 10px;">其他</div>
          <div class="form-line">
            <div>
              <div class="line-text">合同跟进人：</div>
              <div class="line-info">{{formData.fellowPeopleName || '无'}}</div>
            </div>
            <div>
              <div class="line-text">金额修订说明：</div>
              <div class="line-info">{{formData.memo || '无'}}</div>
            </div>
          </div>
        </form>
      </div>
    </el-drawer>

    <el-dialog title="合同明细" :visible.sync="dialogFormVisible" class="detailedDialog" width="1000px;z-index: 1000000">
      <el-tabs v-model="detailedDialogTabs" type="card" >
        <el-tab-pane label="租金明细" name="rent">
          <div v-if="!formData.leaseContractManagerDetail && !formData.leaseContractManagerDetails">暂无</div>
          <div v-if="formData.leaseContractManagerDetail || formData.leaseContractManagerDetails" style="margin-bottom: 20px">
            <div style="display: flex;justify-content: space-between;line-height: 30px;">
                <span style="line-height: 40px;">
                  <span style="color: #7387a3;">租金总额：系统计算总额：</span>
                  {{rentTotal1}}元
                  <span style="color: #7387a3;">；修改后总额：</span>
                  {{rentTotal2}}元
                </span>
            </div>

            <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
              <div style="width: 300px;">区间</div>
              <div style="width: 100px;">费用类型</div>
              <div style="width: 200px;">付款日</div>
              <div style="width: 150px;">最终单价</div>
              <div style="width: 100px;">系统计算金额</div>
              <div style="width: 100px;">修订金额</div>
            </div>
            <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;text-align: left;">
              租金保证金
            </div>
            <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
              <div style="width: 300px;overflow: hidden" :title="formData.leaseContractManagerDetail.duration">{{formData.leaseContractManagerDetail.duration}}</div>
              <div style="width: 100px;overflow: hidden" :title="formData.leaseContractManagerDetail.feeType">{{formData.leaseContractManagerDetail.feeType}}</div>
              <div style="width: 200px;overflow: hidden" :title="formData.leaseContractManagerDetail.payDeadline">{{formData.leaseContractManagerDetail.payDeadline}}</div>
              <div style="width: 150px;overflow: hidden" title="-">-</div>
              <div style="width: 100px;overflow: hidden" :title="formData.leaseContractManagerDetail.mustReceive">{{formData.leaseContractManagerDetail.mustReceive || '0'}}元</div>
              <div style="width: 100px;overflow: hidden" :title="formData.leaseContractManagerDetail.actualReceive">{{formData.leaseContractManagerDetail.actualReceive || '0'}}元</div>
            </div>
            <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;text-align: left;">
              租金
            </div>
            <div style="text-align: center;line-height: 36px;">
              <div style="display: flex;justify-content: space-between;" v-for="item in formData.leaseContractManagerDetails" :key="item.duration">
                <div style="width: 300px;">{{item.duration}}</div>
                <div style="width: 100px;">{{item.feeType}}</div>
                <div style="width: 200px;">{{item.payDeadline}}</div>
                <div style="width: 150px;">{{item.contractPer}}{{item.contractPerText}}</div>
                <div style="width: 100px;">{{item.mustReceive || '0'}}元</div>
                <div style="width: 100px;">{{item.actualReceive || '0'}}元</div>
              </div>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="物业费明细" name="second">
          <div v-if="!formData.propertyContractManagerDetail && !formData.propertyContractManagerDetails">暂无</div>
          <div v-if="formData.propertyContractManagerDetail || formData.propertyContractManagerDetails" style="margin-bottom: 20px">
            <div style="display: flex;justify-content: space-between;line-height: 30px;">
                <span style="line-height: 40px;">
                  <span style="color: #7387a3;">物业费总额：系统计算总额：</span>
                  {{propertyTotal1}}元
                  <span style="color: #7387a3;">；修改后总额：</span>
                  {{propertyTotal2}}元
                </span>
            </div>

            <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
              <div style="width: 300px;">区间</div>
              <div style="width: 100px;">费用类型</div>
              <div style="width: 200px;">付款日</div>
              <div style="width: 150px;">最终单价</div>
              <div style="width: 100px;">系统计算金额</div>
              <div style="width: 100px;">修订金额</div>
            </div>
            <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;text-align: left;">
              物业保证金
            </div>
            <div style="display: flex;justify-content: space-between; text-align: center;line-height: 36px;">
              <div style="width: 300px;overflow: hidden" :title="formData.propertyContractManagerDetail.duration">{{formData.propertyContractManagerDetail.duration}}</div>
              <div style="width: 100px;overflow: hidden" :title="formData.propertyContractManagerDetail.feeType">{{formData.propertyContractManagerDetail.feeType}}</div>
              <div style="width: 200px;overflow: hidden" :title="formData.propertyContractManagerDetail.payDeadline">{{formData.propertyContractManagerDetail.payDeadline}}</div>
              <div style="width: 150px;overflow: hidden" title="-">-</div>
              <div style="width: 100px;overflow: hidden" :title="formData.propertyContractManagerDetail.mustReceive">{{formData.propertyContractManagerDetail.mustReceive}}元</div>
              <div style="width: 100px;overflow: hidden" :title="formData.propertyContractManagerDetail.actualReceive">{{formData.propertyContractManagerDetail.actualReceive}}元</div>
            </div>
            <div style="line-height: 35px; background-color: #F4F4F4;color: #7387a3;padding-left: 20px;text-align: left;">
              物业费
            </div>
            <div style="text-align: center;line-height: 36px;">
              <div style="display: flex;justify-content: space-between;" v-for="item in formData.propertyContractManagerDetails">
                <div style="width: 300px;">{{item.duration}}</div>
                <div style="width: 100px;">{{item.feeType}}</div>
                <div style="width: 200px;">{{item.payDeadline}}</div>
                <div style="width: 150px;">{{item.contractPer}}{{item.contractPerText}}</div>
                <div style="width: 100px;">{{item.mustReceive}}元</div>
                <div style="width: 100px;">{{item.actualReceive}}元</div>
              </div>
            </div>
          </div>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>


    <!--房源信息-->
    <el-dialog title="房屋信息" :visible.sync="roomInfoDialogVisible" width="800px">
      <div style="display: flex;justify-content: space-between;margin-bottom: 20px;">
        <div style="padding-left: 5px;border-left: #00A0E6 3px solid;text-align: left;font-size: 16px;font-weight: 500;">房间详情</div>
      </div>
      <div style="display: flex;justify-content: flex-start;text-align: left;padding: 0 20px;margin-bottom: 10px;">
        <div style="width: 33%;">房间号： {{roomInfo.roomNumber}}</div>
        <div style="width: 33%;">房屋面积：{{roomInfo.roomArea}}m²</div>
        <div style="width: 33%;">人数： {{personListInRoom.length || 0}}</div>
      </div>

      <div style="padding-left: 5px;border-left: #00A0E6 3px solid;text-align: left;font-size: 16px;font-weight: 500;">关联人员</div>
      <div style="display: flex;justify-content: flex-start;flex-wrap: wrap;">
        <div v-if="personListInRoom.length === 0">
          <div style="width: 120px;height: 160px;border: 1px dashed #00A0E6;border-radius: 10px;margin: 20px;display: flex;align-items: center;cursor: pointer;" @click="toPersonAddPage()">
            <div style="text-align: center;margin: 0 auto;color: #00A0E6;">立即添加</div>
          </div>
        </div>
        <div v-else v-for="person in personListInRoom" :key="person.code" style="display: flex;justify-content: flex-start;width: 50%;align-items: center;padding: 0 20px;margin: 30px 0;">
          <img :src="person.yqPicUrl" alt="人员照片" style="width: 120px;height: 160px;background-color: #00A0E6;border-radius: 10px;margin-right: 10px;">
          <div style="padding: 10px 0;line-height: 20px;">
            <div style="display: flex;justify-content: flex-start;">
              <div style="width: 85px;text-align: right;">姓名：</div>
              <div>{{person.name}}</div>
            </div>
            <div style="display: flex;justify-content: flex-start;">
              <div style="width: 85px;text-align: right;">性别：</div>
              <div v-if="person.sex === '0'">男</div>
              <div v-else>女</div>
            </div>
            <div style="display: flex;justify-content: flex-start;">
              <div style="width: 85px;text-align: right;">身份证号码：</div>
              <span>{{person.identityNumber || '暂无'}}</span>
            </div>
            <div style="display: flex;justify-content: flex-start;">
              <div style="width: 85px;text-align: right;">联系电话：</div>
              <span>{{person.phone}}</span>
            </div>
            <div style="display: flex;justify-content: flex-start;">
              <div style="width: 85px;text-align: right;">人员类型：</div>
              <div>{{person.personTypeText}}</div>
            </div>
            <div  @click="toPersonModifyPage(person)" style="color: #00A0E6;cursor: pointer;margin-top: 20px;">
              <i class="el-icon-edit"></i>修改
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-drawer :visible.sync="currentFloorDisplayDrawer" direction="btt" size="3.75rem">
      <div slot="title" class="floor-display-drawer-title">{{currentFloorDisplayName}} <span class="floor-display-drawer-subtitle" @click="showDialog(currentFloorDisplayInfo.floor)">{{currentFloorDisplayInfo.floor.area}}m²  <i class=el-icon-damai-bianji></i></span></div>
      <div class="floor-display-drawer">

        <div class="floor-display-main" :style="{width: isFullScreen ? '100%': '4.1625rem' ,height: isFullScreen ? '100%' : '2.48125rem', position: isFullScreen ? 'fixed' : 'relative', top: '0', left: '0'}">
          <i :title="isFullScreen ? '取消全屏' : '全屏'" :class="[isFullScreen ? 'el-icon-damai-ic_tuichuquanping' : 'el-icon-damai-ic_quanping']" @click="showFloorDisplayFullScreen"></i>
          <div class="floor-display-main-top-line" style="height: 30px;line-height: 30px;">
            <el-radio-group v-model="floorDisplayRadio" size="small">
              <el-radio-button :label="1">立体展示</el-radio-button>
              <el-radio-button :label="2">平面展示</el-radio-button>
              <el-radio-button :label="3">楼层结构图</el-radio-button>
            </el-radio-group>

            <div class="floor-display-main-top-line-operation">
              <img src="../../../assets/three/compass.svg" class="floor-display-main-top-line-operation-img" alt="" v-if="floorDisplayRadio === 2">
              <button-confirm @confirm="wantModifyRoomLayout = true" value="修改" v-if="!wantModifyRoomLayout && floorDisplayRadio === 2" />
              <button-confirm @confirm="confirmModifyRoomLayout" v-if="wantModifyRoomLayout && floorDisplayRadio === 2" />
              <button-cancel @cancel="cancelModifyRoomLayout" v-if="wantModifyRoomLayout && floorDisplayRadio === 2" />
            </div>
          </div>
          <three-floor class="animate__animated animate__zoomIn" v-if="changeState && currentFloorDisplayDrawer && floorDisplayRadio === 1" :style="{width: floorBoxWidth, height: floorBoxHeight, margin: '0 auto'}" :roomList="currentFloorDisplayInfo.rooms" @roomClick="changeCurrentFloorDisplayRoom" />
          <!--          :draggable="false" :resizable="false"-->
          <div class="floor-display-main-vdr-box animate__animated animate__zoomIn" :style="{width: floorBoxWidth, height: floorBoxHeight, margin: '0 auto'}" v-if="changeState && currentFloorDisplayDrawer && floorDisplayRadio === 2">
            <vdr :draggable="wantModifyRoomLayout" :resizable="wantModifyRoomLayout" :parent="true" :class="[isFullScreen ? 'floor-display-main-item-full-screen' : 'floor-display-main-item']" @resizing ="changeFloorDisplayRoomSize" @resizestop="changeFloorDisplayRoomSizeStop" @dragging="changeFloorDisplayRoomPosition" @deactivated="confirmChangeRoom(room)" v-for="room in currentFloorDisplayInfo.rooms" :w="room.width" :h="room.high" :x="room.x" :y="room.y" :key="room.code" :style="{backgroundColor: (room.rentStatus === '0' ? '#9A9A48': (room.rentStatus === '1' ? '#18887B': (room.rentStatus === '2' ? '#364BA2': (room.rentStatus === '4' ? '#50B5FF': (room.rentStatus === '5' ? '#E56000': (room.rentStatus === '6' ? '#F29324': (room.rentStatus === '7' ? '#5E41FE': (room.rentStatus === '8' ? '#8B36EF': (room.rentStatus === '9' ? '#FC5A5A': (room.rentStatus === '10' ? '#1FB6CB': (room.rentStatus === '11' ? '#5A844A': '#cccccc')))))))))))}" v-if="room.roomNumber !== '未分配'">
              <div class="floor-display-main-item-info" @click="changeCurrentFloorDisplayRoom(room)" >
                <div class="floor-display-main-item-owner">{{room.roomNumber}} / {{room.roomArea}}m² <span style="display: inline-block" v-if="room.officeSeat"> / {{room.officeSeat}}工位</span></div>
                <div class="floor-display-main-item-name">{{room.enterpriseName || '无'}}</div>
              </div>
            </vdr>
          </div>

          <div class="floor-display-main-structure-diagram-box" :style="{width: floorBoxWidth, height: floorBoxHeight, margin: '0 auto'}" v-if="floorDisplayRadio === 3">
            <img :src="currentFloorDisplayStructureDiagram" alt="" v-if="currentFloorDisplayStructureDiagram" class="floor-display-main-structure-diagram-img" @click="upStructureDiagram">
            <div class="floor-display-main-structure-diagram-choose-again-tip" @click="upStructureDiagram" v-if="currentFloorDisplayStructureDiagram">重新上传</div>
            <input id="uploadStructureDiagramImg" name="file" accept="image/*" type="file" multiple="multiple" style="display: none;" @change="upStructureDiagramData" />
            <div class="floor-display-main-structure-diagram-choose-box" @click="upStructureDiagram" v-if="!currentFloorDisplayStructureDiagram">
              <div><i class="el-icon-plus"></i></div>
              <div class="floor-display-main-structure-diagram-choose-tip">点击上传图片</div>
            </div>
          </div>
        </div>
        <div class="floor-display-info">
          <div class="floor-display-info-item">
            <div class="floor-display-info-item-title">房间号</div>
            <div class="floor-display-info-item-main">{{currentFloorDisplayRoom.roomNumber}}</div>
          </div>
          <div class="floor-display-info-item">
            <div class="floor-display-info-item-title">房间面积</div>
            <div class="floor-display-info-item-main">{{currentFloorDisplayRoom.roomArea}}m²</div>
          </div>
          <div class="floor-display-info-item">
            <div class="floor-display-info-item-title">房源朝向</div>
            <div class="floor-display-info-item-main">{{currentFloorDisplayRoom.roomLocation}}</div>
          </div>
          <div class="floor-display-info-item">
            <div class="floor-display-info-item-title">住户名称</div>
            <div class="floor-display-info-item-main">{{currentFloorDisplayRoom.enterpriseName}}</div>
          </div>
          <div class="floor-display-info-item">
            <div class="floor-display-info-item-title">人员数量</div>
            <div class="floor-display-info-item-main">50</div>
          </div>
          <div class="floor-display-info-item">
            <div class="floor-display-info-item-title">到期日</div>
            <div class="floor-display-info-item-main">{{currentFloorDisplayRoom.contractEndDate}}</div>
          </div>
          <div class="floor-display-info-item">
            <div class="floor-display-info-item-title">租赁状态</div>
            <div class="floor-display-info-item-main">
              <el-tag :color="currentFloorDisplayRoom.rentStatus === '0' ? '#9A9A48': (currentFloorDisplayRoom.rentStatus === '1' ? '#18887B': (currentFloorDisplayRoom.rentStatus === '2' ? '#364BA2': (currentFloorDisplayRoom.rentStatus === '4' ? '#50B5FF': (currentFloorDisplayRoom.rentStatus === '5' ? '#E56000': (currentFloorDisplayRoom.rentStatus === '6' ? '#F29324': (currentFloorDisplayRoom.rentStatus === '7' ? '#5E41FE': (currentFloorDisplayRoom.rentStatus === '8' ? '#8B36EF': (currentFloorDisplayRoom.rentStatus === '9' ? '#FC5A5A': (currentFloorDisplayRoom.rentStatus === '10' ? '#1FB6CB': (currentFloorDisplayRoom.rentStatus === '11' ? '#5A844A': '#cccccc'))))))))))">{{currentFloorDisplayRoom.rentStatusText}}</el-tag>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>

  </div>
</template>

<script>
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import TheTree from "../../../components/Tree/the-tree";
import ButtonAdd from "../../../components/Button/ButtonAdd";
import InputSearch from "../../../components/Input/InputSearch";
import { api } from "../../api/HousingManagement";
import { treeApi } from "../../api/TreeApi";
import { errorHandler } from "../../../utils/errorHandler";
import { nAlert, nError, nSuccess } from "../../../utils/notice";
import { bus } from "../../../utils/bus";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import ButtonExport from "../../../components/Button/ButtonExport";
import TableMain from "../../../components/Table/TableMain";
import InputSelect from "../../../components/Input/InputSelect";
import ButtonConfirmNext from "../../../components/Button/ButtonConfirmNext";
import ThreeFloor from "../../../components/Three/threeFloor";
import ButtonCancel from "../../../components/Button/ButtonCancel";
import ButtonDeleteData from "../../../components/Button/ButtonDelete";
import ButtonConfirm from "../../../components/Button/ButtonConfirm";
import $ from "jquery";

export default {
  components: {
    ButtonConfirm,
    ButtonDeleteData,
    ButtonCancel,
    ThreeFloor,
    ButtonConfirmNext,
    InputSelect,
    TableMain,
    ButtonExport,
    InputSearch,
    ButtonAdd,
    ButtonUpload,
    TheTree,
    Breadcrumb,
  },
  name: "housing-management",
  data() {
    return {
      theyqCode: "",
      frontPermissionCodes: "",
      breadcrumb: [
        {
          value: "资源中心",
          name: "yq-information",
        },
        {
          value: "房屋管理",
        },
      ],
      addHouseBuildingName: "housing-building-add",
      addHouseRouterName: "housing-add",
      areaWidthValue: "按面积比例查看",
      areaWidthSelect: false,
      addBtnValue: "新建房间",
      filterText: "",
      treeOptions: {
        1: ["add"],
        2: ["add", "patch", "delete"],
        3: ["patch", "delete"],
      },
      treeUpdate: {
        render: (code) => {
          return treeApi.getYqInfoChildrenById(code).then((list) => {
            list.forEach((tree) => {
              tree._label = tree.yqName;
            });
            return list;
          });
        },
        addNode: (node) => {
          node.yqName = node._label;
          return treeApi.addyqInfo(node);
        },
        removeNode: (code) => {
          return treeApi.deleteyqInfoByCodes(code);
        },
        editNode: (node) => {
          node.yqName = node._label;
          return treeApi.updateyqInfo(node);
        },
      },
      housingPageActiveName: "housing_resources",
      activeTab: "1",
      exportUrl: "",
      uploadUrl: "",
      buildingExportUrl: "",
      buildingUploadUrl: "",
      searchKey: "",
      yqCode: "",
      operationArr: ["modify", "delete"],
      roomOperationArr: ["modify"],
      housingTableHead: [
        {
          prop: "buildingName",
          label: "楼栋名称",
        },
        {
          prop: "floorName",
          label: "所在楼层",
        },
        {
          prop: "roomNumber",
          label: "房间号",
        },
        {
          prop: "roomArea",
          label: "面积(m²)",
          width: "100",
        },
        {
          prop: "officeSeat",
          label: "工位数",
        },
        {
          prop: "fitmentText",
          label: "装修",
          width: "100",
        },
        {
          prop: "roomRent",
          label: "预租单价(元/m²·天)",
        },
        {
          prop: "rentStatusText",
          label: "租赁状态",
        },
        {
          prop: "enterpriseName",
          label: "住户名称",
        },
      ],
      rentStatus: "",
      areaSort: "",
      rentStatusList: [
        {
          key: "",
          label: "全部",
        },
        {
          key: "0",
          label: "空置",
        },
        {
          key: "1",
          label: "在租",
        },
        {
          key: "4",
          label: "已预订",
        },
        {
          key: "5",
          label: "30天内到期",
        },
        {
          key: "6",
          label: "90天内到期",
        },
        {
          key: "7",
          label: "180天内到期",
        },
        {
          key: "8",
          label: "未租满",
        },
        {
          key: "9",
          label: "已到期",
        },
      ],
      areaSortList: [
        {
          key: "",
          label: "默认",
        },
        {
          key: "1",
          label: "面积从小到大",
        },
        {
          key: "2",
          label: "面积从大到小",
        },
      ],
      housingTableData: [],
      housingTotal: 0,
      housingPageSize: 10,
      housingPageNum: 1,
      tableHead: [
        {
          prop: "name",
          label: "楼栋名称",
        },
        {
          prop: "floorsSum",
          label: "楼栋总层数",
        },
        {
          prop: "totalArea",
          label: "楼栋总面积(m²)",
        },
        {
          prop: "enterpriseCount",
          label: "入驻住户总数",
        },
      ],
      tableData: [],
      total: 0,
      pageSize: 10,
      pageNum: 1,
      selectionArr: [],
      requestData: {
        searchKey: "",
      },
      collapseActiveName: ["all", "current"],
      allBuildingData: {},
      buildingList: [],
      currentBuildingFloorArr: [],
      perFloorArea: null,
      roomShowType: 'routine',
      tabAllData: [],
      tabNormalData: [],
      tabNearData: [],
      tabNearData_negative: [],
      tabNearData_30: [],
      tabNearData_90: [],
      tabNearData_180: [],
      tabNotRentFullData: [],
      tabScheduledData: [],
      tabSignData: [],
      tabVacantData: [],
      tabVacantDataLength: "",
      tabNormalDataLength: "",
      tabNearDataLength: "",
      tabNearData_negativeLength: "",
      tabNearData_30Length: "",
      tabNearData_90Length: "",
      tabNearData_180Length: "",
      tabNotRentFullDataLength: "",
      tabScheduledDataLength: "",
      tabSignDataLength: "",
      publicUseDataLength: "",
      leaseDataLength: '',
      selfUseDataLength: "",
      changeFloorAreaVisible: false,
      dialogInputWidth: "120px",
      currentFloorCode: "",
      currentFloorName: "",
      currentFloorBelongBuildingCode: "",
      currentFloorBelongBuildingName: "",
      currentFloorArea: "",
      newFloorArea: "",
      currentFloorLength: '',
      currentFloorWidth: '',

      housingShowValue: "查看房源列表",
      housingTypeStatus: true,
      windowLeftBox: false,
      windowLeftInfo: {},
      windowLeftTotal: 0,
      windowLeftPageNum: 1,
      windowLeftPageSize: 10,
      contractTableHead: [
        {
          prop: "leaseName",
          label: "承租主体",
        },
        {
          prop: "contractStartDate",
          label: "合同开始时间",
        },
        {
          prop: "contractEndDate",
          label: "合同结束时间",
        },
        {
          prop: "contractSignDate",
          label: "合同签订时间",
        },
        {
          prop: "statusText",
          label: "合同状态",
        },
      ],
      contractList: [],
      activeName: "",
      roomLoading: true,
      drawer: false,

      rentTotal1: 0,
      rentTotal2: 0,
      propertyTotal1: 0,
      propertyTotal2: 0,
      formData: {
        contractManagerIncreaseLeases: [],
        contractManagerIncreaseProperties: [],
        contractManagerDiscountProperties: [],
      },
      currentCode: "",
      dialogFormVisible: false,
      detailedDialogTabs: "rent",
      contractTemplateList: [],
      contractDialogFormVisible: false,
      downloadContractLoading: false,

      showHousingRightBox: false,

      currentBuildingData: "",
      currentRoomShowOnPageTypeStatus: '12',
      currentRoomShowOnPageStatus: "all",

      // 户室变量
      currentBuildingCode: "",
      roomInfoDialogVisible: false,
      roomInfo: {},
      roomDefaultArea: "",
      isModifyRoomArea: true,
      personListInRoom: [],

      permissionCodes: '',

      // 楼层展示
      currentFloorDisplayName: '',
      currentFloorDisplayStructureDiagram: '',
      currentFloorDisplayStructureDiagramBase64: '',
      currentFloorDisplayDrawer: false,
      floorBoxWidth: '3.75rem',
      floorBoxHeight: '1.875rem',
      isFullScreen: false,
      changeState: true,
      floorDisplayRadio: 1,
      wantModifyRoomLayout: false,
      currentFloorDisplayInitialInfo: {},
      currentFloorDisplayInfo: {
        floor: ''
      },
      currentFloorDisplayRoom: {},
      roomChangeX: '',
      roomChangeY: '',
      roomChangeWidth: '',
      roomChangeHeight: '',
      roomChangeType: ''
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes
    this.theyqCode = bus.global.yqCode;
    this.frontPermissionCodes = bus.global.frontPermissionCodes;
    this.uploadUrl = api.importRoomInfo;
    this.buildingExportUrl = `${api.exportBuilding}?yq-app-code=${bus.global.yqCode}&kj-type=gy`;
    this.buildingUploadUrl = api.importBuilding;
    this.housingPageActiveName =
      window.sessionStorage.getItem("housingManagementPageHousingTabState") ||
      "housing_resources";
    // this.getBuildingPage()
    this.getBuildingList();
    this.getStatisticsData();
  },
  methods: {
    getStatisticsData() {
      this.$axios
        .post(api.getStatisticsData, {})
        .then((res) => {
          let data = res.data.data;
          this.allBuildingData = data;
        })
        .catch(errorHandler("获取数据失败"));
    },
    beforeDownload() {
      this.exportUrl = `${api.exportRoomInfo}?yq-app-code=${bus.global.yqCode}&kj-type=gy&token=${bus.global.token}&searchKey=${this.requestData.searchKey}&buildingCode=${this.yqCode}`;
    },
    changeTheBuildingData(buildData) {
      this.showHousingRightBox = false
      setTimeout(() => {
        this.showHousingRightBox = true
        this.getBuildingByCodeWithDetail(buildData.code)
        this.yqCode = buildData.code;
        window.sessionStorage.setItem(
          "housingManagementPageBuildingTabState",
          this.yqCode
        );
        this.getList();
        this.getRoomStatusNumber();
      }, 800)
    },
    changeCurrentRoomShowOnPageTypeStatus(status) {
      this.currentRoomShowOnPageTypeStatus = status;
      this.currentRoomShowOnPageStatus = "all"; 
      this.updateFilteredCounts(); // 更新筛选后的计数
    },

    // 计算筛选后的房间数量
    updateFilteredCounts() {
      if (!this.tabAllData || this.tabAllData.length === 0) return;

      let leaseCount = 0;
      let publicUseCount = 0;
      let selfUseCount = 0;

      // 遍历所有楼层和房间
      this.tabAllData.forEach(build => {
        build.rooms.forEach(room => {
          // 只统计符合当前状态筛选条件的房间
          const matchesStatusFilter =
            this.currentRoomShowOnPageStatus === 'all' ||
            room.rentStatus === this.currentRoomShowOnPageStatus;

          if (room.type === '12' && matchesStatusFilter) {
            leaseCount++;
          }
          if (room.type === '10') {
            publicUseCount++;
          }
          if (room.type === '11') {
            selfUseCount++;
          }
        });
      });

      // 更新显示的数量
      this.leaseDataLength = leaseCount;
      this.publicUseDataLength = publicUseCount;
      this.selfUseDataLength = selfUseCount;
    },

    changeCurrentRoomShowOnPageStatus(status) {
      this.currentRoomShowOnPageStatus = status;
      this.updateFilteredCounts(); // 更新筛选后的计数?
    },
    uploadSuccess(data) {
      const e = errorHandler("导入失败")(data);
      if (!(e instanceof Error)) {
        nSuccess("导入成功");
        this.refreshData();
      }
    },
    refreshData() {
      this.getBuildingPage();
      this.getBuildingList();
    },
    getBuildingPage() {
      let reqData = this.requestData;
      reqData.pageNum = this.pageNum;
      reqData.pageSize = this.pageSize;
      // let accountName = bus.global.accountName
      // this.$axios.post(`${api.getBuildingPage}/${accountName}`, reqData)
      this.$axios
        .post(api.getBuildingPage, reqData)
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            this.total = res.data.data.total;
            this.tableData = data;
          }
        })
        .catch(errorHandler("获取楼栋分页失败"));
    },
    getBuildingList() {
      // let accountName = bus.global.accountName
      // this.$axios.post(`${api.getBuildingList}/${accountName}`, {})
      this.showHousingRightBox = false
      setTimeout(() => {
        this.showHousingRightBox = true
      }, 800)
      this.$axios
        .post(api.getBuildingList, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            this.buildingList = data;
            if (data.length > 0) {
              // this.currentBuildingData = data[0];
              this.getBuildingByCodeWithDetail(data[0].code)
            }

            this.yqCode =
              window.sessionStorage.getItem(
                "housingManagementPageBuildingTabState"
              ) || "";
            if (!this.yqCode) {
              if (this.buildingList.length !== 0) {
                this.yqCode = this.buildingList[0].code;
                window.sessionStorage.setItem(
                  "housingManagementPageBuildingTabState",
                  this.yqCode
                );
                // this.perFloorArea = parseInt(this.buildingList[0].perFloorArea)
                this.currentBuildingFloorArr = this.buildingList[0].floors;
                this.getList();
                this.getRoomStatusNumber();
              }
            } else {
              this.buildingList.map((v) => {
                if (this.yqCode === v.code) {
                  // this.perFloorArea = parseInt(v.perFloorArea)
                  this.currentBuildingFloorArr = v.floors;
                  this.getList();
                  this.getRoomStatusNumber();
                }
              });
            }
          }
        })
        .catch(errorHandler("获取楼栋列表失败"));
    },

    getBuildingByCodeWithDetail (code) {
      this.$axios.get(`${api.getBuildingByCodeWithDetail}/${code}`, {})
        .then((res) => {
          this.currentBuildingData = res.data.data
        })
        .catch(errorHandler("获取楼栋数据失败"));
    },

    getPageByRentStatus(v) {
      this.pageNum = 1;
      this.rentStatus = v.value;
      this.getPage();
    },

    getPageByAreaSort(v) {
      this.pageNum = 1;
      this.areaSort = v.value;
      this.getPage();
    },

    searchKeyGetPage(v) {
      this.pageNum = 1;
      this.searchKey = v;
      this.getPage();
    },

    getPage() {
      let yqCode = "";
      if (this.yqCode.indexOf(bus.global.yqCode) !== -1) {
        yqCode = this.yqCode;
      }
      this.$axios
        .post(api.getRoomInfoPage, {
          buildingCode: yqCode,
          areaSort: this.areaSort,
          rentStatus: this.rentStatus,
          pageNum: this.housingPageNum,
          pageSize: this.housingPageSize,
          searchKey: this.searchKey,
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data.list;
            data.map((v) => {
              if (v.fitment === "0") {
                v.fitmentText = "精装";
              } else if (v.fitment === "1") {
                v.fitmentText = "简装";
              } else if (v.fitment === "2") {
                v.fitmentText = "毛坯";
              }
              if (v.rentStatus === "0") {
                v.rentStatusText = "空置";
              } else if (v.rentStatus === "1") {
                v.rentStatusText = "在租";
              } else if (v.rentStatus === "4") {
                v.rentStatusText = "已预订";
              } else if (v.rentStatus === "5") {
                v.rentStatusText = "30天内到期";
              } else if (v.rentStatus === "6") {
                v.rentStatusText = "90天内到期";
              } else if (v.rentStatus === "7") {
                v.rentStatusText = "180天内到期";
              } else if (v.rentStatus === "8") {
                v.rentStatusText = "未租满";
              } else if (v.rentStatus === "9") {
                v.rentStatusText = "已到期";
              }
            });
            this.roomLoading = false;
            this.housingTotal = res.data.data.total;
            this.housingTableData = data;
          }
        })
        .catch(errorHandler("获取房源列表失败"));
    },

    getList() {
      this.$axios
        .get(`${api.getRoomInfoListGroupByFloor}/${this.yqCode}`, {})
        .then((res) => {
          this.tabAllData = [];
          this.tabNormalData = [];
          this.tabNearData = [];
          this.tabVacantData = [];
          this.tabScheduledData = [];
          this.tabNearData_negative = [];
          this.tabNearData_30 = [];
          this.tabNearData_90 = [];
          this.tabNearData_180 = [];
          this.tabNotRentFullData = [];
          this.tabSignData = [];
          let data = res.data.data;
          // let tabAllData = data

          data.map(build => {
            build.rooms.map(room => {
              if (!room.beds) {
                room.beds = []
              }
              room.widthOnPageByProportion = `${((parseFloat(room.roomArea) / parseFloat(build.floor.area)) * 100).toFixed(2)}%`
            })
          })
          this.tabAllData = data;
          this.tabNormalData = data;
          this.tabNearData = data;
          this.tabVacantData = data;
          this.tabScheduledData = data;
          this.tabNearData_negative = data;
          this.tabNearData_30 = data;
          this.tabNearData_90 = data;
          this.tabNearData_180 = data;
          this.tabNotRentFullData = data;
          this.tabSignData = data;

          let multiple = this.isFullScreen ? (document.documentElement.clientWidth / 1600 * 2.4) : (document.documentElement.clientWidth / 1600)
          data.map(v => {
            if (this.currentFloorDisplayInitialInfo.floor) {


              if (v.floor.code === this.currentFloorDisplayInitialInfo.floor.code) {
                let statusList = [
                  {key: '0', value: '空置'},
                  {key: '1', value: '正常在租'},
                  {key: '2', value: '待签订'},
                  {key: '4', value: '已预定'},
                  {key: '5', value: '30天内到期'},
                  {key: '6', value: '90天内到期'},
                  {key: '7', value: '180天内到期'},
                  {key: '8', value: '未租满'},
                  {key: '9', value: '已逾期'},
                  {key: '10', value: '公用'},
                  {key: '11', value: '自用'},
                ]
                let currentFloorDisplayInitialInfo = this.deepClone(v)

                if (this.isFullScreen) {
                  let floorAspectRatio = 1
                  if (currentFloorDisplayInitialInfo.floor.floorLength && currentFloorDisplayInitialInfo.floor.floorWidth) {
                    floorAspectRatio = parseFloat(currentFloorDisplayInitialInfo.floor.floorLength / currentFloorDisplayInitialInfo.floor.floorWidth)
                  } else {
                    floorAspectRatio = 2
                  }
                  if (floorAspectRatio >= 2) {
                    this.floorBoxWidth = '9rem'
                    this.floorBoxHeight = `${9 / floorAspectRatio}rem`
                  } else {
                    this.floorBoxWidth = `${4.5 * floorAspectRatio}rem`
                    this.floorBoxHeight = '4.5rem'
                  }
                } else {
                  let floorAspectRatio = 1
                  if (currentFloorDisplayInitialInfo.floor.floorLength && currentFloorDisplayInitialInfo.floor.floorWidth) {
                    floorAspectRatio = parseFloat(currentFloorDisplayInitialInfo.floor.floorLength / currentFloorDisplayInitialInfo.floor.floorWidth)
                  } else {
                    floorAspectRatio = 2
                  }
                  if (floorAspectRatio >= 2) {
                    this.floorBoxWidth = '3.75rem'
                    this.floorBoxHeight = `${3.75 / floorAspectRatio}rem`
                  } else {
                    this.floorBoxWidth = `${1.875 * floorAspectRatio}rem`
                    this.floorBoxHeight = '1.875rem'
                  }
                }

                currentFloorDisplayInitialInfo.rooms.map(room => {
                  // room.width = parseFloat(room.width * multiple)
                  // room.high = parseFloat(room.high * multiple)

                  room.high = parseFloat(room.high * multiple)
                  room.width = parseFloat(room.roomArea * parseFloat(this.floorBoxWidth) * 160 * parseFloat(this.floorBoxHeight) * 160 / parseFloat(currentFloorDisplayInitialInfo.floor.area) / room.high)

                  room.x = parseFloat(room.x * multiple)
                  room.y = parseFloat(room.y * multiple)

                  statusList.map(status => {
                    if (room.rentStatus === status.key) {
                      room.rentStatusText = status.value
                    }
                  })
                })
                this.currentFloorDisplayInitialInfo = this.deepClone(currentFloorDisplayInitialInfo)
                this.currentFloorDisplayInfo = currentFloorDisplayInitialInfo
                this.changeState = true

                console.log(this.currentFloorDisplayInfo)
              }
            }
          })

          this.updateFilteredCounts();

          this.roomLoading = false;
        })
        .catch(errorHandler("获取房间信息失败"));
    },

    // 获取房源统计
    getRoomStatusNumber() {
      this.$axios
        .get(`${api.getRoomStatusNumber}/${this.yqCode}`, {})
        .then((res) => {
          let data = res.data.data;
          this.tabVacantDataLength = data["0"] || 0;
          this.tabNormalDataLength = data["1"] || 0;
          this.tabSignDataLength = data["2"] || 0;
          this.tabScheduledDataLength = data["3"] || 0;

          this.tabNearData_30Length = data["5"] || 0;
          this.tabNearData_90Length = data["6"] || 0;
          this.tabNearData_180Length = data["7"] || 0;
          this.tabNotRentFullDataLength = data["8"] || 0;
          this.tabNearData_negativeLength = data["9"] || 0;
          this.publicUseDataLength = data["10"] || 0;
          this.selfUseDataLength = data["11"] || 0;

          this.leaseDataLength =  this.tabVacantDataLength + this.tabNormalDataLength + this.tabSignDataLength + this.tabNearData_30Length + this.tabNearData_90Length + this.tabNearData_180Length + this.tabNotRentFullDataLength + this.tabNearData_negativeLength
        })
        .catch(errorHandler("获取房源数量失败"));
    },

    // 已弃置
    getRoomInfoList() {
      this.$axios
        .post(api.getRoomInfoList, {
          searchKey: this.searchKey,
          yqCode: this.yqCode,
        })
        .then((res) => {
          this.tabAllData = [];
          this.tabNormalData = [];
          this.tabNearData = [];
          this.tabVacantData = [];
          this.tabScheduledData = [];
          this.tabNearData_negative = [];
          this.tabNearData_30 = [];
          this.tabNearData_90 = [];
          this.tabNearData_180 = [];
          this.tabNotRentFullData = [];
          this.tabSignData = [];
          let data = res.data.data;
          if (data.length > 0) {
            let tabAllData = data;
            let tabNormalData = [];
            let tabNearData = [];
            let tabNearData_negative = [];
            let tabNearData_30 = [];
            let tabNearData_90 = [];
            let tabNearData_180 = [];
            let tabNotRentFullData = [];
            let tabVacantData = [];
            let tabScheduledData = [];
            let tabSignData = [];
            this.currentBuildingFloorArr = [];
            data.map((v) => {
              this.buildingList.map((build) => {
                if (v.buildingCode === build.code) {
                  build.floors.map((floor) => {
                    this.currentBuildingFloorArr.push(floor);
                    if (floor.code === v.floorCode) {
                      v.perFloorArea = floor.area;
                      v.boxWidth = (
                        (parseFloat(v.roomArea) / v.perFloorArea) *
                        100
                      ).toFixed(2);
                      v.boxWidthWithoutScale = (
                        1 / build.floors.length
                      ).toFixed(2);
                    }
                  });
                }
              });
              if (v.rentStatus === "0") {
                v.bgColor = "#668CA9bb";
                tabVacantData.push(v);
              } else if (v.rentStatus === "1") {
                v.bgColor = "#00CC66bb";
                tabNormalData.push(v);
              } else if (v.rentStatus === "2") {
                v.bgColor = "#0EC1C7bb";
                tabSignData.push(v);
              } else if (v.rentStatus === "4") {
                v.bgColor = "#00A6EFbb";
                tabScheduledData.push(v);
              } else if (v.rentStatus === "5") {
                v.bgColor = "#B22222bb";
                tabNearData_30.push(v);
              } else if (v.rentStatus === "6") {
                v.bgColor = "#FF4500bb";
                tabNearData_90.push(v);
              } else if (v.rentStatus === "7") {
                v.bgColor = "#FF9933bb";
                tabNearData_180.push(v);
              } else if (v.rentStatus === "8") {
                v.bgColor = "#20B2AAbb";
                tabNotRentFullData.push(v);
              } else if (v.rentStatus === "9") {
                v.bgColor = "#630D0Dbb";
                tabNearData_negative.push(v);
              }

              if (v.rentStatus === "0") {
                v.tabVacantDataBgColor = "#668CA9bb";
              } else {
                v.tabVacantDataBgColor = "#cccccc";
              }

              if (v.rentStatus === "1") {
                v.tabNormalDataBgColor = "#00CC66bb";
              } else {
                v.tabNormalDataBgColor = "#cccccc";
              }

              if (v.rentStatus === "2") {
                v.tabSignDataBgColor = "#0EC1C7bb";
              } else {
                v.tabSignDataBgColor = "#cccccc";
              }

              if (v.rentStatus === "4") {
                v.tabScheduledDataBgColor = "#00A6EFbb";
              } else {
                v.tabScheduledDataBgColor = "#cccccc";
              }

              if (v.rentStatus === "5") {
                v.tabNearData_30BgColor = "#B22222bb";
              } else {
                v.tabNearData_30BgColor = "#cccccc";
              }

              if (v.rentStatus === "6") {
                v.tabNearData_90BgColor = "#FF4500bb";
              } else {
                v.tabNearData_90BgColor = "#cccccc";
              }

              if (v.rentStatus === "7") {
                v.tabNearData_180BgColor = "#FF9933bb";
              } else {
                v.tabNearData_180BgColor = "#cccccc";
              }

              if (v.rentStatus === "8") {
                v.tabNotRentFullDataBgColor = "#20B2AAbb";
              } else {
                v.tabNotRentFullDataBgColor = "#cccccc";
              }

              if (v.rentStatus === "9") {
                v.tabNearData_negativeBgColor = "#630D0Dbb";
              } else {
                v.tabNearData_negativeBgColor = "#cccccc";
              }
            });
            this.tabVacantDataLength = tabVacantData.length;
            this.tabNormalDataLength = tabNormalData.length;
            this.tabNearDataLength = tabNearData.length;
            this.tabScheduledDataLength = tabScheduledData.length;
            this.tabNearData_negativeLength = tabNearData_negative.length;
            this.tabNearData_30Length = tabNearData_30.length;
            this.tabNearData_90Length = tabNearData_90.length;
            this.tabNearData_180Length = tabNearData_180.length;
            this.tabNotRentFullDataLength = tabNotRentFullData.length;
            this.tabSignDataLength = tabSignData.length;
            let tabAllDataArr = [];

            for (let i = 0; i < this.currentBuildingFloorArr.length; i++) {
              let arr = [];
              let residualArea = parseFloat(
                this.currentBuildingFloorArr[i].area
              ).toFixed(2);
              tabAllData.map((theData) => {
                if (
                  theData.floor.code === this.currentBuildingFloorArr[i].code
                ) {
                  theData.rooms.map((roomInfo) => {
                    residualArea = parseFloat(
                      residualArea - roomInfo.roomArea
                    ).toFixed(2);
                    arr.push(theData);
                  });
                }
              });
              if (residualArea > 0) {
                arr.push({
                  roomArea: residualArea,
                  bgColor: "#bfbfbf",
                  roomNumber: "未分配",
                  enterpriseName: "",
                });
              }
              this.tabAllData.push(arr);
              tabAllDataArr.push(arr);
            }

            // for (let j = 0; j < tabAllDataArr.length; j++) {
            //   tabAllDataArr[j].map(v => {
            //     if (v.rentStatus === '0') {
            //       v.tabVacantDataBgColor = '#668CA9'
            //     } else {
            //       v.tabVacantDataBgColor = '#cccccc'
            //     }
            //
            //     if (v.rentStatus === '1') {
            //       v.tabNormalDataBgColor = '#00CC66'
            //     } else {
            //       v.tabNormalDataBgColor = '#cccccc'
            //     }
            //
            //     if (v.rentStatus === '2') {
            //       v.tabSignDataBgColor = '#0EC1C7'
            //     } else {
            //       v.tabSignDataBgColor = '#cccccc'
            //     }
            //
            //     if (v.rentStatus === '4') {
            //       v.tabScheduledDataBgColor = '#00A6EF'
            //     } else {
            //       v.tabScheduledDataBgColor = '#cccccc'
            //     }
            //
            //     if (v.rentStatus === '5') {
            //       v.tabNearData_30BgColor = '#B22222'
            //     } else {
            //       v.tabNearData_30BgColor = '#cccccc'
            //     }
            //
            //     if (v.rentStatus === '6') {
            //       v.tabNearData_90BgColor = '#FF4500'
            //     } else {
            //       v.tabNearData_90BgColor = '#cccccc'
            //     }
            //
            //     if (v.rentStatus === '7') {
            //       v.tabNearData_180BgColor = '#FF9933'
            //     } else {
            //       v.tabNearData_180BgColor = '#cccccc'
            //     }
            //
            //     if (v.rentStatus === '8') {
            //       v.tabNotRentFullDataBgColor = '#20B2AA'
            //     } else {
            //       v.tabNotRentFullDataBgColor = '#cccccc'
            //     }
            //
            //     if (v.rentStatus === '9') {
            //       v.tabNearData_negativeBgColor = '#630D0D'
            //     } else {
            //       v.tabNearData_negativeBgColor = '#cccccc'
            //     }
            //   })
            // }
            this.tabNormalData = tabAllDataArr;
            this.tabNearData = tabAllDataArr;
            this.tabVacantData = tabAllDataArr;
            this.tabScheduledData = tabAllDataArr;
            this.tabNearData_negative = tabAllDataArr;
            this.tabNearData_30 = tabAllDataArr;
            this.tabNearData_90 = tabAllDataArr;
            this.tabNearData_180 = tabAllDataArr;
            this.tabNotRentFullData = tabAllDataArr;
            this.tabSignData = tabAllDataArr;
          } else {
            if (this.currentBuildingFloorArr) {
              let tabAllDataArr = [];
              for (let i = 0; i < this.currentBuildingFloorArr.length; i++) {
                let arr = [];
                let residualArea = parseFloat(
                  this.currentBuildingFloorArr[i].area
                ).toFixed(2);
                if (residualArea > 0) {
                  arr.push({
                    roomArea: residualArea,
                    bgColor: "#bfbfbf",
                    roomNumber: "未分配",
                    enterpriseName: "",
                  });
                }
                this.tabAllData.push(arr);
                tabAllDataArr.push(arr);
              }
            }

            this.tabVacantDataLength = 0;
            this.tabNormalDataLength = 0;
            this.tabNearDataLength = 0;
            this.tabScheduledDataLength = 0;
            this.tabNearData_negativeLength = 0;
            this.tabNearData_30Length = 0;
            this.tabNearData_90Length = 0;
            this.tabNearData_180Length = 0;
            this.tabNotRentFullDataLength = 0;
            this.tabSignDataLength = 0;

            this.tabNormalData = [];
            this.tabNearData = [];
            this.tabVacantData = [];
            this.tabScheduledData = [];
            this.tabNearData_negative = [];
            this.tabNearData_30 = [];
            this.tabNearData_90 = [];
            this.tabNearData_180 = [];
            this.tabNotRentFullData = [];
            this.tabSignData = [];
          }
          console.log(this.tabAllData);
        })
        .catch(errorHandler("获取房间信息失败"));
    },

    changeHousingPagination(data) {
      this.housingPageNum = data[0];
      this.housingPageSize = data[1];
      this.getPage();
    },

    changePagination(data) {
      this.pageNum = data[0];
      this.pageSize = data[1];
      this.getBuildingPage();
    },

    changyqCode(v) {
      this.yqCode = v.data.code;
      this.getList();
      this.getRoomStatusNumber();
    },

    buildSearch(data) {
      this.requestData.searchKey = data;
      this.getBuildingPage();
    },
    search(data) {
      this.pageNum = 1;
      this.searchKey = data;
      this.getList();
      this.getRoomStatusNumber();
    },
    tabClick(tab, event) {},

    // 房源信息是否按比例查看
    changeAreaWidth() {
      if (this.areaWidthSelect) {
        this.areaWidthSelect = false;
        this.areaWidthValue = "按面积比例查看";
      } else {
        this.areaWidthSelect = true;
        this.areaWidthValue = "按平均比例查看";
      }
    },

    // 切换房源展示方式
    changeHousingShowType() {
      if (this.housingShowValue === "查看房源列表") {
        this.housingShowValue = "查看剖面图";
        this.getPage();
      } else {
        this.housingShowValue = "查看房源列表";
      }
      this.housingTypeStatus = !this.housingTypeStatus;
    },

    changeWindowLeftPagination(data) {
      this.windowLeftPageNum = data[0];
      this.windowLeftPageSize = data[1];
      this.getContractByRoomCode();
    },

    contractDataToWindowLeft() {
      this.drawer = false;
      this.windowLeftBox = true;
    },

    //点击列表内容展示房间及合同信息
    housingRowClick(row, column, cell, event) {
      this.windowLeftBox = true;
      this.windowLeftInfo = row;
      this.getContractByRoomCode();
    },

    //点击房间展示房间及合同信息
    housingBoxClick(roomInfo) {
      if (roomInfo.roomNumber === "未分配") {
        this.$router.push({
          name: this.addHouseRouterName,
        });
      } else {
        this.windowLeftBox = true;
        this.windowLeftInfo = roomInfo;
        this.getContractByRoomCode();
      }
    },

    // 获取当前房源关联的合同信息
    getContractByRoomCode() {
      this.$axios
        .post(`${api.getContractPage}`, {
          pageNum: this.windowLeftPageNum,
          pageSize: this.windowLeftPageSize,
          roomInfoCode: this.windowLeftInfo.code,
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            let list = data.list || [];
            this.windowLeftTotal = data.total;
            list.map((v) => {
              if (v.status === "1") {
                v.statusText = "新建待确认";
              } else if (v.status === "2") {
                v.statusText = "续租待确认";
              } else if (v.status === "3") {
                v.statusText = "退租待确认";
              } else if (v.status === "4") {
                v.statusText = "新建待审批";
              } else if (v.status === "5") {
                v.statusText = "续租待审批";
              } else if (v.status === "6") {
                v.statusText = "退租待审批";
              } else if (v.status === "7") {
                v.statusText = "正常执行";
              } else if (v.status === "8") {
                v.statusText = "到期未处理";
              } else if (v.status === "9") {
                v.statusText = "已作废";
              } else if (v.status === "10") {
                v.statusText = "已归档";
              } else if (v.status === "11") {
                v.statusText = "续租待执行";
              } else if (v.status === "12") {
                v.statusText = "退租待执行";
              } else if (v.status === "13") {
                v.statusText = "已续租";
              } else if (v.status === "14") {
                v.statusText = "已退租";
              } else if (v.status === "16") {
                v.statusText = "换租待确认";
              } else if (v.status === "17") {
                v.statusText = "换租待审批";
              } else if (v.status === "18") {
                v.statusText = "换租待执行";
              } else if (v.status === "19") {
                v.statusText = "已换租";
              }
            });
            this.contractList = list;
          }
        })
        .catch(errorHandler("获取合同信息失败"));
    },

    handleClose(done) {
      done();
      this.windowLeftBox = true;
    },

    // 点击合同展示合同详情
    windowLeftRowClick(row, event, column) {
      this.windowLeftBox = false;
      this.drawer = true;
      this.getContractByCode(row.code);
    },

    // 查询合同详情
    getContractByCode(code) {
      this.$axios
        .get(`${api.getContractByCode}/${code}`, {})
        .then((res) => {
          if (res.data.retCode === 1) {
            let data = res.data.data;
            if (!data.leaseContractManagerDetails) {
              data.leaseContractManagerDetails = [];
            }
            if (!data.leaseContractManagerDetail) {
              data.leaseContractManagerDetail = [];
            }
            if (!data.contractManagerIncreaseLeases) {
              data.contractManagerIncreaseLeases = []
            }
            if (!data.contractManagerLeaseItems) {
              data.contractManagerLeaseItems = []
            }
            if (!data.contractManagerDiscountLeases) {
              data.contractManagerDiscountLeases = []
            }
            if (!data.contractManagerPropertyItems) {
              data.contractManagerPropertyItems = []
            }
            if (!data.contractManagerIncreaseProperties) {
              data.contractManagerIncreaseProperties = []
            }
            if (!data.contractManagerDiscountProperties) {
              data.contractManagerDiscountProperties = []
            }
            data.roomList.map(roomItem => {
              let bedsList = roomItem.beds || [], bedsNameList = []
              bedsList.map(bedItem => {
                bedsNameList.push(bedItem.bedsNumber)
              })
              roomItem._bedsLabel = bedsNameList.join(',')
              roomItem._label = `${roomItem.buildingName}/${roomItem.floorName}层/${roomItem.roomNumber}`
            })
            let rentTotal1 = 0;
            let rentTotal2 = 0;
            let propertyTotal1 = 0;
            let propertyTotal2 = 0;
            if (data.leaseContractManagerDetails) {
              data.leaseContractManagerDetails.map((v) => {
                if (v.contractPerUnit === '1') {
                  v.contractPerText = "元 / 间 / 月"
                } else if (v.contractPerUnit === '2') {
                  v.contractPerText = "元 / 间 / 天"
                } else if (v.contractPerUnit === '3') {
                  v.contractPerText = "元 / 床 / 月"
                } else if (v.contractPerUnit === '4') {
                  v.contractPerText = "元 / 床 / 天"
                }
                rentTotal1 = rentTotal1 + parseFloat(v.mustReceive);
                rentTotal2 = rentTotal2 + parseFloat(v.actualReceive);
              });
            }
            if (data.propertyContractManagerDetails) {
              data.propertyContractManagerDetails.map((v) => {
                if (v.contractPerUnit === '1') {
                  v.contractPerText = "元 / 间 / 月"
                } else if (v.contractPerUnit === '2') {
                  v.contractPerText = "元 / 间 / 天"
                } else if (v.contractPerUnit === '3') {
                  v.contractPerText = "元 / 床 / 月"
                } else if (v.contractPerUnit === '4') {
                  v.contractPerText = "元 / 床 / 天"
                }
                propertyTotal1 = propertyTotal1 + parseFloat(v.mustReceive);
                propertyTotal2 = propertyTotal2 + parseFloat(v.actualReceive);
              });
            }
            if (data.leaseContractManagerDetail) {
              rentTotal1 =
                rentTotal1 +
                parseFloat(data.leaseContractManagerDetail.mustReceive);
            }
            if (data.leaseContractManagerDetail) {
              rentTotal2 =
                rentTotal2 +
                parseFloat(data.leaseContractManagerDetail.actualReceive);
            }
            if (data.propertyContractManagerDetail) {
              propertyTotal1 =
                propertyTotal1 +
                parseFloat(data.propertyContractManagerDetail.mustReceive);
            }
            if (data.propertyContractManagerDetail) {
              propertyTotal2 =
                propertyTotal2 +
                parseFloat(data.propertyContractManagerDetail.actualReceive);
            }
            this.rentTotal1 = rentTotal1.toFixed(2);
            this.rentTotal2 = rentTotal2.toFixed(2);
            this.propertyTotal1 = propertyTotal1.toFixed(2);
            this.propertyTotal2 = propertyTotal2.toFixed(2);
            this.formData = data;
          }
        })
        .catch(errorHandler("查询合同失败"));
    },

    // 切换管理
    housingTabClick() {
      window.sessionStorage.setItem(
        "housingManagementPageHousingTabState",
        this.housingPageActiveName
      );
    },
    // 切换楼栋
    changeStoriedBuilding() {
      this.roomLoading = true;
      if (this.yqCode.indexOf(this.theyqCode) === -1) {
        this.activeTab = "1";
        this.housingTypeStatus = false;
      } else {
        this.activeTab = "1";
        window.sessionStorage.setItem(
          "housingManagementPageBuildingTabState",
          this.yqCode
        );
        // if (!this.housingTypeStatus) {
        //   this.housingTypeStatus = !this.housingTypeStatus
        // }
        // this.housingShowValue = '查看房源列表'
        this.buildingList.map((v) => {
          if (v.code === this.yqCode) {
            // this.perFloorArea = parseInt(v.perFloorArea)
            this.currentBuildingFloorArr = v.floors;
          }
        });
        this.getList();
        this.getRoomStatusNumber();
      }
      this.getPage();
    },
    toAddHousingPage(data, itemVal) {
      if (!itemVal.code) {
        window.sessionStorage.setItem(
          "housingManagementPageBuildingTabState",
          this.yqCode
        );
        window.sessionStorage.setItem("housingManagementPageLevel", data.code);
        this.$router.push({
          name: "housing-add",
        });
      }
    },
    roomClick(itemValue) {
      if (itemValue.code) {
        console.log(itemValue);
      }
    },
    toModifyRoomPage(code) {
      this.toModifyPage(code);
    },
    toModifyPage(id) {
      if (!id) {
        return;
      }
      this.$router.push({
        path: `/housing_modify/${id}`,
      });
    },
    goToModifyBuildingPage(code) {
      this.$router.push({
        path: `/housing_building_modify/${code}`,
      });
    },
    deleteBuild(code) {
      this.$confirm("是否确认删除此楼栋？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.deleteLine(code);
        })
        .catch(() => {
          console.log("取消删除");
        });
    },
    deleteLine(code) {
      this.$axios
        .post(api.deleteBuildingByCodes, [code])
        .then((res) => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.getBuildingList();
          }
        })
        .catch(errorHandler("删除楼栋失败"));
    },
    deleteItem(code, status) {
      if (status === "1") {
        nAlert("当前房间已有住户租赁，无法删除！");
        return false;
      }
      this.$confirm("是否确认删除该房间？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.deleteConfirm(code);
        })
        .catch(() => {
          console.log("取消删除");
        });
    },
    deleteConfirm(code) {
      this.$axios
        .post(api.deleteRoomInfoByCodes, [code])
        .then((res) => {
          if (res.data.retCode === 1) {
            nSuccess("删除成功");
            this.getList();
            this.getRoomStatusNumber();
          }
        })
        .catch(errorHandler("删除房间信息失败"));
    },
    // 删除楼层
    deleteFloorByCodes(code) {
      this.$confirm("是否确认删除该楼层？", "提示", {
        type: "warning",
      })
        .then(() => {
          this.$axios
            .post(api.deleteFloorByCodes, [code])
            .then((res) => {
              if (res.data.retCode === 1) {
                nSuccess("删除成功");
                this.getBuildingPage();
                this.getBuildingList();
              }
            })
            .catch(errorHandler("删除房间信息失败"));
        })
        .catch(() => {
          console.log("取消删除");
        });
    },

    toShowProportion () {
      this.roomShowType = 'proportion'
    },

    toShowRoutine () {
      this.roomShowType = 'routine'
    },

    showDialog(v) {
      this.changeFloorAreaVisible = true;
      this.currentFloorArea = v.area;
      this.currentFloorCode = v.code;
      this.currentFloorName = v.name;
      this.currentFloorLength = v.floorLength
      this.currentFloorWidth = v.floorWidth
      this.currentFloorBelongBuildingCode = v.buildingCode;
      this.currentFloorBelongBuildingName = v.buildingName;
    },
    changeFloorArea() {
      if (!this.newFloorArea) {
        nError("请输入新面积");
        return false;
      }
      if (!this.currentFloorLength) {
        nError("请输入楼层长度");
        return false;
      }
      if (!this.currentFloorWidth) {
        nError("请输入楼层高度");
        return false;
      }
      this.$axios
        .post(api.updateFloorArea, {
          name: this.currentFloorName,
          code: this.currentFloorCode,
          area: this.newFloorArea,
          floorWidth: this.currentFloorWidth,
          floorLength: this.currentFloorLength,
          buildingCode: this.currentFloorBelongBuildingCode,
          buildingName: this.currentFloorBelongBuildingName,
        })
        .then((res) => {
          if (res.data.retCode === 1) {
            nSuccess("修改成功");
            this.changeFloorAreaVisible = false;
            this.getBuildingList();
            this.changeState = false
            // setTimeout(() => {
            //   this.changeState = true
            // }, 800)
          }
        })
        .catch(errorHandler("修改楼层面积失败"));
    },

    toPersonModifyPage(person) {
      this.$router.push({
        path: `/person_modify/${person.code}`,
      });
    },

    toPersonAddPage() {
      this.$router.push({
        name: `person-add`,
      });
    },

    showRoomDialog(room) {
      this.roomInfoDialogVisible = true;
      this.roomInfo = room;
      this.roomDefaultArea = room.roomArea;
      let personTypeList = [
        {key: '', label: '全部'},
        {key: 1, label: '入住人'},
        {key: 2, label: '签约人'},
        {key: 3, label: '工作人员'},
        {key: 4, label: '管理员'},
        {key: 0, label: '游客'},
      ]
      this.$axios.post(api.getPersonList, {roomCode: room.code,})
        .then((res) => {
          let data = res.data.data;
          let personData = [];
          data.map((v) => {
            if (!v.yqPicUrl) {
              v.yqPicUrl = require("../../../assets/noPhoto.png");
            }
            personTypeList.map(type => {
              if (type.key === v.personType && v.personType !== '') {
                v.personTypeText = type.label
              }
            })
          });
          data.map((person) => {
            personData.push(person);
          });
          this.personListInRoom = personData;
        })
        .catch(errorHandler("查询人员失败"));
    },

    showCurrentFloorDisplayDrawer (floor) {
      this.currentFloorDisplayDrawer = false
      this.isFullScreen = false
      this.changeState = true
      this.floorDisplayRadio = 1
      this.wantModifyRoomLayout = false
      let statusList = [
        {key: '0', value: '空置'},
        {key: '1', value: '正常在租'},
        {key: '2', value: '待签订'},
        {key: '4', value: '已预定'},
        {key: '5', value: '30天内到期'},
        {key: '6', value: '90天内到期'},
        {key: '7', value: '180天内到期'},
        {key: '8', value: '未租满'},
        {key: '9', value: '已逾期'},
        {key: '10', value: '公用'},
        {key: '11', value: '自用'},
      ]
      let floorData = this.deepClone(floor)
      let multiple = document.documentElement.clientWidth / 1600
      let floorAspectRatio = 1
      if (floor.floor.floorLength && floor.floor.floorWidth) {
        floorAspectRatio = parseFloat(floor.floor.floorLength / floor.floor.floorWidth)
      } else {
        floorAspectRatio = 2
      }
      if (floorAspectRatio >= 2) {
        this.floorBoxWidth = '3.75rem'
        this.floorBoxHeight = `${3.75 / floorAspectRatio}rem`
      } else {
        this.floorBoxWidth = `${1.875 * floorAspectRatio}rem`
        this.floorBoxHeight = '1.875rem'
      }
      floorData.rooms.map(v => {
        v.high = parseFloat(v.high * multiple)
        v.width = parseFloat(v.roomArea * parseFloat(this.floorBoxWidth) * 160 * parseFloat(this.floorBoxHeight) * 160 / parseFloat(floorData.floor.area) / v.high)
        // v.width = parseFloat(v.width * multiple)
        // v.high = parseFloat(v.high * multiple)
        v.x = parseFloat(v.x * multiple)
        v.y = parseFloat(v.y * multiple)

        statusList.map(status => {
          if (v.rentStatus === status.key) {
            v.rentStatusText = status.value
          }
        })
      })
      this.currentFloorDisplayDrawer = true
      this.currentFloorDisplayInitialInfo = this.deepClone(floorData)
      this.currentFloorDisplayInfo = floorData
      this.currentFloorDisplayRoom = floorData.rooms[0]
      this.currentFloorDisplayName = `${floorData.floor.buildingName}${floorData.floor.name}层`
      this.currentFloorDisplayStructureDiagram = floorData.floor.structurePic
    },

    // 深拷贝对象
    deepClone(obj) {
      var o;
      // 如果  他是对象object的话  , 因为null,object,array  也是'object';
      if (typeof obj === "object") {
        // 如果  他是空的话
        if (obj === null) {
          o = null;
        } else {
          // 如果  他是数组arr的话
          if (obj instanceof Array) {
            o = [];
            for (let i = 0, len = obj.length; i < len; i++) {
              o.push(this.deepClone(obj[i]));
            }
          }
          // 如果  他是对象object的话
          else {
            o = {};
            for (let j in obj) {
              o[j] = this.deepClone(obj[j]);
            }
          }
        }
      } else {
        o = obj;
      }
      return o;
    },

    changeCurrentFloorDisplayRoom (room) {
      this.currentFloorDisplayRoom = room
    },

    confirmChangeRoom (room) {
      if (!this.roomChangeX && !this.roomChangeY && !this.roomChangeWidth && !this.roomChangeHeight) {
        return false
      }
      this.currentFloorDisplayInfo.rooms.map(v => {
        if (v.code === room.code) {
          v.x = this.roomChangeX
          v.y = this.roomChangeY
          // if (this.roomChangeType === 'zoom') {
            // v.width = this.roomChangeWidth || v.width
            // v.high = this.roomChangeHeight || v.high

            // v.width = parseFloat(v.roomArea * parseFloat(this.floorBoxWidth) * 160 * parseFloat(this.floorBoxHeight) * 160 / parseFloat(this.currentFloorDisplayInfo.floor.area) / v.high)
          // }
          this.roomChangeX = ''
          this.roomChangeY = ''
          this.roomChangeWidth = ''
          this.roomChangeHeight = ''
        }
      })
    },

    // 方块调整大小时更新四要素
    changeFloorDisplayRoomSize (x, y, width, height) {
      this.roomChangeX = x
      this.roomChangeY = y
      this.roomChangeWidth = width
      this.roomChangeHeight = height
      this.roomChangeType = 'zoom'
    },

    // 调整大小结束
    changeFloorDisplayRoomSizeStop () {
      let room = this.currentFloorDisplayRoom
      this.currentFloorDisplayInfo.rooms.map(v => {
        if (v.code === room.code) {
          v.high = this.roomChangeHeight || v.high
          v.width = parseFloat(v.roomArea * parseFloat(this.floorBoxWidth) * 160 * parseFloat(this.floorBoxHeight) * 160 / parseFloat(this.currentFloorDisplayInfo.floor.area) / v.high)
        }
      })
    },

    // 方块移动时更新方块位置
    changeFloorDisplayRoomPosition (x, y) {
      this.roomChangeX = x
      this.roomChangeY = y
      this.roomChangeType = 'drag'
    },

    // 确认修改楼层布局
    async confirmModifyRoomLayout () {
      const loading = this.$loading({
        lock: true,
        text: '请稍后',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      await this.updateRoomInfoList();
      loading.close()
      setTimeout(() => {
        this.getList();
        this.$nextTick(() => {
          this.wantModifyRoomLayout = false
        })
      }, 500)
    },

    async updateRoomInfoList () {
      for (let i = 0; i < this.currentFloorDisplayInfo.rooms.length; i++) {
        let reqData = this.deepClone(this.currentFloorDisplayInfo.rooms[i])
        if (reqData.roomNumber !== '未分配') {
          let multiple = this.isFullScreen ? (document.documentElement.clientWidth / 1600 * 2.4) : (document.documentElement.clientWidth / 1600)
          reqData.width = parseFloat(reqData.width / multiple)
          reqData.high = parseFloat(reqData.high / multiple)
          reqData.x = parseFloat(reqData.x / multiple)
          reqData.y = parseFloat(reqData.y / multiple)
          this.$axios.post(api.updateRoomInfo, reqData)
            .then(res => {})
            .catch(errorHandler('修改房间失败'))
        }
      }
    },

    // 取消修改楼层布局
    cancelModifyRoomLayout () {
      this.currentFloorDisplayInfo = this.deepClone(this.currentFloorDisplayInitialInfo)
      this.$nextTick(() => {
        this.wantModifyRoomLayout = false
      })
    },

    // 全屏操作
    showFloorDisplayFullScreen () {
      this.changeState = false
      this.isFullScreen = !this.isFullScreen
      setTimeout(() => {
        this.changeState = true
      }, 500)
    },

    // 修改房源结构图
    upStructureDiagram () {
      $('#uploadStructureDiagramImg')
        .click() // 隐藏了input:file样式后，点击头像就可以本地上传
        .on('change', function () {})
    },
    upStructureDiagramData () {
      let that = this;
      const oFReader = new FileReader();
      const file = document.getElementById("uploadStructureDiagramImg").files[0];
      oFReader.readAsDataURL(file);
      oFReader.onloadend = function (oFRevent) {
        const src = oFRevent.target.result;
        that.currentFloorDisplayStructureDiagramBase64 = src;
        that.uploadPicture();
      };
    },
    // 上传图片成功后，修改楼层信息
    uploadPicture() {
      this.$axios.post(api.uploadImg, {
          picData: this.currentFloorDisplayStructureDiagramBase64,
        })
        .then((res) => {
          this.currentFloorDisplayStructureDiagram = res.data.data;
          this.$axios.post(api.updateFloorArea, {
            code: this.currentFloorDisplayInfo.floor.code,
            area: this.currentFloorDisplayInfo.floor.area,
            structurePic: this.currentFloorDisplayStructureDiagram
          })
            .then((res) => {
              if (res.data.retCode === 1) {
                nSuccess("修改成功");
                this.changeFloorAreaVisible = false;
                this.getBuildingList();
                this.changeState = false
                setTimeout(() => {
                  this.changeState = true
                }, 300)
              }
            })
            .catch(errorHandler("修改楼层面积失败"));
        })
        .catch(errorHandler("图片上传失败"));
    },
  },
  watch: {
    housingPageActiveName(val) {
      if (val === "housing_resources") {
        this.getBuildingList();
      }
    },
    isFullScreen (val) {
      if (this.isFullScreen) {
        this.$nextTick(() => {
          let multiple = 2.4
          let floorAspectRatio = 1
          if (this.currentFloorDisplayInfo.floor.floorLength && this.currentFloorDisplayInfo.floor.floorWidth) {
            floorAspectRatio = parseFloat(this.currentFloorDisplayInfo.floor.floorLength / this.currentFloorDisplayInfo.floor.floorWidth)
          } else {
            floorAspectRatio = 2
          }
          if (floorAspectRatio >= 2) {
            this.floorBoxWidth = '9rem'
            this.floorBoxHeight = `${9 / floorAspectRatio}rem`
          } else {
            this.floorBoxWidth = `${4.5 * floorAspectRatio}rem`
            this.floorBoxHeight = '4.5rem'
          }
          this.currentFloorDisplayInfo.rooms.map(v => {
            v.width = parseFloat(v.width * multiple)
            v.high = parseFloat(v.high * multiple)
            v.x = parseFloat(v.x * multiple)
            v.y = parseFloat(v.y * multiple)
          })
          this.currentFloorDisplayInitialInfo.rooms.map(v => {
            v.width = parseFloat(v.width * multiple)
            v.high = parseFloat(v.high * multiple)
            v.x = parseFloat(v.x * multiple)
            v.y = parseFloat(v.y * multiple)
          })
        })
      } else {
        this.$nextTick(() => {
          let multiple = 2.4
          let floorAspectRatio = 1
          if (this.currentFloorDisplayInfo.floor.floorLength && this.currentFloorDisplayInfo.floor.floorWidth) {
            floorAspectRatio = parseFloat(this.currentFloorDisplayInfo.floor.floorLength / this.currentFloorDisplayInfo.floor.floorWidth)
          } else {
            floorAspectRatio = 2
          }
          if (floorAspectRatio >= 2) {
            this.floorBoxWidth = '3.75rem'
            this.floorBoxHeight = `${3.75 / floorAspectRatio}rem`
          } else {
            this.floorBoxWidth = `${1.875 * floorAspectRatio}rem`
            this.floorBoxHeight = '1.875rem'
          }
          this.currentFloorDisplayInfo.rooms.map(v => {
            v.width = parseFloat(v.width / multiple)
            v.high = parseFloat(v.high / multiple)
            v.x = parseFloat(v.x / multiple)
            v.y = parseFloat(v.y / multiple)
          })
          this.currentFloorDisplayInitialInfo.rooms.map(v => {
            v.width = parseFloat(v.width / multiple)
            v.high = parseFloat(v.high / multiple)
            v.x = parseFloat(v.x / multiple)
            v.y = parseFloat(v.y / multiple)
          })
        })
      }
    }
  },
};
</script>

<style lang="less">
.housing-manage {
  padding: 0!important;
  background: #F0F0F7;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  overflow-x: hidden;
  .el-button.is-plain:focus {
    color: #48576a;
    border: 1px solid #d7d7d7;
  }
  .el-button.is-plain:hover {
    background: #fff;
    border-color: #00a0e6;
    color: #00a0e6;
  }

  .page-content {
    text-align: left;
    display: flex;
    flex: 1;
    justify-content: space-between;
    flex-direction: column;
    .page-content-top-statistics-data {
      width: 1342px;
      height: 100px;
      background: #FFFFFF;
      border-radius: 7px;
      margin: 17px auto;
      overflow: hidden;
      .page-content-top-statistics-data-title-line {
        padding: 0 17px;
        margin: 9px 0 2px 0;
        font-size: 16px;
        line-height: 21px;
        color: rgba(51, 51, 51, 0.85);
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .page-content-top-statistics-data-title-tip {
          width: 7px;
          height: 22px;
          background: #1362FF;
          border-radius: 4px;
        }
        .page-content-top-statistics-data-title {
          padding: 0 10px;
          margin-right: 20px;
        }
        .page-content-top-statistics-data-title-left {
          display: flex;
          justify-content: flex-start;
          align-items: center;
        }
        .page-content-top-statistics-data-title-right {
          line-height: 30px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      }
      .page-content-top-statistics-data-line {
        display: flex;
        justify-content: space-between;
        align-items: center;
        .page-content-top-statistics-data-line-item {
          width: 177px;
          height: 62px;
          background: #FFFFFF;
          border-radius: 7px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          .page-content-top-statistics-data-line-num {
            font-size: 24px;
            font-weight: bold;
            line-height: 30px;
            color: #333333;
            margin-bottom: 8px;
          }
          .page-content-top-statistics-data-line-tip {
            font-weight: 400;
            color: #a6a6a6;
            font-size: 14px;
          }
        }
        .page-content-top-statistics-data-line-item-division {
          width: 1px;
          height: 24px;
          background: #DEE2EA;
        }
      }
    }

    .page-main {
      width: 1342px;
      margin: 0 auto;
      flex: 1;
      display: flex;
      justify-content: flex-start;
      align-items: flex-start;
      .housing-left {
        width: 203px;
        height: 100%;
        padding: 20px 13px 20px 13px;
        margin-right: 17px;
        background: #FFFFFF;
        box-shadow: 0 0 5px rgba(0, 0, 0, 0.16);
        border-radius: 7px;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        .housing-top-title-line {
          width: 177px;
          margin-bottom: 10px;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          .housing-top-title-tip {
            width: 7px;
            height: 22px;
            background: #1362FF;
            border-radius: 4px;
          }
          .housing-top-title-main {
            flex: 1;
            margin-left: 7px;
            font-size: 15px;
            font-weight: 500;
            line-height: 21px;
            color: rgba(51, 51, 51, 0.85);
          }
          .housing-top-btn:hover {
            cursor: pointer;
            color: #00a0e6;
          }
        }
        .build-item {
          width: 177px;
          height: 87px;
          background: #FFFFFF;
          border-radius: 7px;
          cursor: pointer;
          padding: 14px 4px;
          margin-bottom: 10px;
          position: relative;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          .build-item-name {
            font-weight: 600;
            color: #333333;
            line-height: 28px;
            font-size: 16px;
          }
          .build-item-floor {
            font-size: 12px;
            color: #999999;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }
        .build-item:after {
          content: "";
          width: 171px;
          height: 1px;
          background: #DEE2EA;
          position: absolute;
          bottom: 0;
          left: 3px;
        }
        .build-item-current {
          width: 177px;
          height: 87px;
          border-radius: 7px;
          cursor: pointer;
          padding: 14px 4px;
          margin-bottom: 10px;
          background-color: #edf2f5;
          position: relative;
          display: flex;
          justify-content: space-between;
          flex-direction: column;
          .build-item-name {
            font-weight: 600;
            color: #1362FF;
            line-height: 28px;
            font-size: 16px;
          }
          .build-item-floor {
            font-size: 12px;
            color: #999999;
            display: flex;
            justify-content: space-between;
            align-items: center;
          }
        }
        .build-item-current:after {
          content: "";
          width: 171px;
          height: 1px;
          background: #DEE2EA;
          position: absolute;
          bottom: 0;
          left: 3px;
        }
        .build-item:hover {
          background-color: #edf2f5;
        }
      }
      .housing-right {
        flex: 1;
        display: flex;
        justify-content: flex-start;
        flex-direction: column;
        .building-right-top {
          height: 60px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          border-bottom: 1px solid #e5ecf1;
          padding: 18px 10px 20px 10px;
          .building-right-top-left {
          }
          .building-right-top-right {
            display: flex;
            justify-content: flex-end;
            align-items: center;
          }
        }

        .housing-right-top {
          width: 100%;
          height: 153px;
          background: #FFFFFF;
          box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
          border-radius: 7px;
          display: flex;
          justify-content: flex-start;
          flex-direction: column;
          overflow: hidden;
          .housing-right-top-name {
            height: 61px;
            padding: 0 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .housing-right-top-name-left {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              color: #1362FF;
              .housing-right-top-name-left-icon {
                font-size: 28px;
              }
              .housing-right-top-name-left-info {
                font-size: 25px;
                margin-left: 3px;
              }
            }
            .housing-right-top-name-right {
              display: flex;
              justify-content: flex-end;
              align-items: center;
            }
          }
          .housing-right-top-division {
            width: 1108px;
            height: 2px;
            background: linear-gradient(45deg, #1362FF 0%, #FFFFFF 100%);
          }
          .housing-right-top-main-line {
            width: 1113px;
            flex: 1;
            display: flex;
            justify-content: space-between;
            align-items: center;
            .housing-right-top-main-line-item {
              width: 159px;
              display: flex;
              justify-content: center;
              flex-direction: column;
              align-items: center;
              .housing-right-top-main-line-num {
                font-size: 22px;
                font-weight: bold;
                color: #333333;
                margin-bottom: 8px;
              }
              .housing-right-top-main-line-tip {
                font-size: 12px;
                font-weight: 400;
                color: #A3AAB7;
              }
            }
          }
        }

        .housing-right-main {
          width: 100%;
          margin-top: 10px;
          padding: 25px;
          background: #FFFFFF;
          box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
          border-radius: 7px;
          .housing-right-main-select-level1-line {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .housing-right-main-select-level1 {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              font-weight: 600;
              font-size: 14px;
              .housing-right-main-select-level1-title {
                color: #333333;
                margin-right: 17px;
              }
              .housing-right-main-select-level1-item {
                cursor: pointer;
                color: #333333;
                margin-right: 33px;
              }
              .housing-right-main-select-level1-item-current {
                cursor: pointer;
                color: #1362FF;
                margin-right: 33px;
              }
            }
          }

          .building-right-select {
            display: flex;
            justify-content: flex-start;
            align-items: flex-start;
            padding: 18px 0 6px 0;
            border-bottom: 1px solid #e5ecf1;
            .building-right-select-info {
              flex: 1;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              flex-wrap: wrap;
              .building-right-select-item {
                cursor: pointer;
                font-size: 12px;
                padding: 6px 0;
                margin-right: 20px;
              }
            }
          }

          .building-right-room-box {
            flex: 1;
            padding: 18px 0 20px 0;
            overflow-y: auto;
            .building-right-room-box-floor {
              margin-top: 30px;
            }
            .building-right-room-box-floor:first-child {
              margin-top: 0;
            }
            .building-right-floor-title {
              font-weight: 600;
              padding-left: 5px;
              margin: 10px 0;
              font-size: 20px;
              line-height: 28px;
              color: #1362FF;
            }
            .building-right-floor-subtitle {
              font-size: 14px;
              font-weight: 400;
              line-height: 18px;
              color: #1362FF;
              margin-left: 5px;
            }
            .building-right-room-proportion-line {
              width: 1072px;
              display: flex;
              justify-content: flex-start;
              align-items: center;
              .building-right-room-proportion-line-item {
                overflow: hidden;
                cursor: pointer;
                font-size: 12px;
                height: 103px;
                border-radius: 3px;
                position: relative;
                .building-right-room-proportion-info {
                  padding: 15px 7px 15px 12px;
                  overflow: hidden;
                  height: 100px;
                  display: flex;
                  justify-content: space-between;
                  align-items: flex-start;
                  flex-direction: column;
                  .building-right-room-proportion-popover-frame {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 7px;
                    height: 103px;
                    border-radius: 3px;
                  }
                  .building-right-room-proportion-name {
                    width: 100%;
                    font-size: 15px;
                    font-weight: 600;
                    color: #333333;
                    margin-bottom: 5px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  .building-right-room-proportion-owner {
                    width: 100%;
                    font-size: 13px;
                    color: #9F9FA8;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
              }
            }
            .building-right-room-line {
              display: flex;
              justify-content: flex-start;
              align-items: center;
              flex-wrap: wrap;
              .building-right-room-item {
                width: 195px;
                height: 103px;
                border-radius: 6px;
                margin: 10px 15px 35px 0;
                position: relative;
                .building-right-room-item-label {
                  height: 28px;
                  line-height: 28px;
                  padding: 0 10px;
                  font-size: 12px;
                  font-weight: 500;
                  color: #FFFFFF;
                  position: absolute;
                  right: 0;
                  top: -14px;
                  border-radius: 0 13px 0 13px;
                }
                .building-right-room-info {
                  width: 195px;
                  height: 103px;
                  padding: 2px 10px 4px;
                  display: flex;
                  cursor: pointer;
                  justify-content: space-between;
                  flex-direction: column;
                  border-radius: 6px;
                  box-shadow: none;
                  .building-right-room-bed-box {
                    width: 120px;
                    height: 32px;
                    padding-bottom: 3px;
                    display: flex;
                    justify-content: space-between;
                    flex-direction: column;
                    flex-wrap: wrap;
                    .building-right-room-bed-box-item {
                      width: 15px;
                      height: 12px;
                    }
                  }
                  .building-right-room-name {
                    color: #333333;
                    font-size: 15px;
                    height: 21px;
                    line-height: 21px;
                    font-weight: 600;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                  .building-right-room-owner {
                    color: #9F9FA8;
                    font-size: 12px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }

                .building-right-room-info:hover {
                  border-radius: 6px 6px 0 0;
                  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.36);
                }
              }
              .building-right-room-item:hover {
                border-radius: 6px 6px 0 0;
              }
            }
          }
        }
      }
    }

  }

  .el-tabs__nav-wrap::after {
    z-index: initial;
  }

  .right-slide-enter,
  .right-slide-leave-active {
    transform: translateX(100%);
  }

  .right-slide-leave-active,
  .right-slide-enter-active {
    transition: all 0.3s;
  }

  .window-left-box {
    position: fixed;
    right: 0;
    top: 0;
    bottom: 0;
    width: 70%;
    z-index: 10;
  }
  .window-left-box .move-enter-active,
  .window-left-box .move-leave-active {
    transition: all 2s linear;
    transform: translate3d(0, 0, 0);
  }
  .window-left-box .move-enter,
  .window-left-box .move-leave {
    transform: translate3d(100%, 0, 0);
  }
  .window-left-main {
    width: 100%;
    height: 100%;
    z-index: 30;
    background: #ffffff;
    padding: 5px 10px;
    overflow: auto;
  }

  .mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    opacity: 0.4;
    z-index: -1;
    background-color: #000000;
    transition: opacity 0.5s ease;
  }

  .contract-detail-on-housing {
    overflow: auto;
    .el-icon-back {
      margin: 20px 20px 10px;
      display: block;
      border: 0;
      font-size: 20px;
      background-color: #ffffff;
      cursor: pointer;
    }
    .el-icon-back:hover {
      color: #00a0e6;
    }
    .flexBox {
      display: flex;
      justify-content: space-between;
    }
    .header-btn-box {
      margin: 20px 0 10px 0;
      color: #337ab7;
      font-size: 14px;
    }
    .header-btn-box a {
      margin-right: 40px;
      cursor: pointer;
    }
    .header-btn-box a:hover {
      color: #00a0e6;
    }
    form {
      width: 90%;
      margin: 0 auto;
      text-align: left;
    }
    .form-title {
      color: #333333;
      font-size: 16px;
      line-height: 28px;
      padding-left: 5px;
      border-left: 3px solid #00a0e6;
    }
    .form-line {
      margin: 20px 0;
      display: flex;
      justify-content: flex-start;
    }
    .form-line > div {
      display: flex;
      justify-content: flex-start;
      line-height: 20px;
    }
    .line-text {
      color: #48576a;
      font-size: 14px;
      margin-right: 10px;
      width: 130px;
      text-align: right;
    }
    .line-info {
      width: 215px;
    }
    .detailedDialog {
      .el-dialog__header {
        text-align: center;
      }
    }
    .contractDialogForm {
      .el-dialog__header {
        text-align: center;
      }
      .operationBox {
        span {
          cursor: pointer;
          color: #337ab7;
        }
        span:hover {
          color: #00a0e6;
        }
      }
      .contractDialogLine {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;
        line-height: 30px;
        padding: 0 15px;
      }
      .contractDialogLine:hover {
        background-color: #eeeeee;
      }
    }
    .form-btn-box {
      margin: 30px auto;
      display: flex;
      justify-content: flex-end;
    }

    .rent-withdrawal-btn {
      border: 1px solid #d7d7d7;
      color: #48576a;
      padding: 8px 16px;
      background-color: #f7f7f7;
    }
    .rent-withdrawal-btn:hover {
      color: #ffffff;
      background-color: #f25721;
    }
  }

  .floor-display-drawer-title {
    text-align: left;
    font-size: 24px;
  }
  .floor-display-drawer-subtitle {
    font-size: 15px;
    font-weight: 500;
    line-height: 21px;
    color: #1362FF;
    margin-left: 10px;
    cursor: pointer;
    .el-icon-damai-bianji {
      font-size: 18px;
      margin-left: 10px;
    }
  }
  .floor-display-drawer {
    height: 100%;
    padding: 0 60px 40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .floor-display-main {
      width: 666px;
      height: 397px;
      padding: 25px 33px;
      background: #FFFFFF;
      border-radius: 7px;
      box-shadow: 0px 0px 8px rgba(0, 0, 0, 0.1);
      position: relative;

      .el-icon-damai-ic_tuichuquanping, .el-icon-damai-ic_quanping {
        cursor: pointer;
        color: #1362FF;
        font-size: 18px;
        z-index: 10;
        position: absolute;
        top: 10px;
        left: 10px;
      }

      .floor-display-main-top-line {
        height: 30px;
        line-height: 30px;
        margin-bottom: 17px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .el-radio-button__orig-radio:checked+.el-radio-button__inner {
          background: #1362ff;
        }
        .floor-display-main-top-line-operation {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          .floor-display-main-top-line-operation-img {
            width: 50px;
            height: 50px;
            margin-right: 20px;
          }
        }
      }
      .floor-display-main-vdr-box {
        position: relative;
        background: #EFF2FF;
        .floor-display-main-item-full-screen, .floor-display-main-item {
          background: #eaeaea;
          .floor-display-main-item-info {
            width: 100%;
            height: 100%;
            color: #FFFFFF;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: center;
            cursor: pointer;
            .floor-display-main-item-owner {
              font-size: 14px;
            }
            .floor-display-main-item-name {
              font-size: 12px;
            }
          }
        }
      }

      .floor-display-main-structure-diagram-box {
        background: #EFF2FF;
        position: relative;
        .floor-display-main-structure-diagram-img {
          width: 100%;
          height: 100%;
          cursor: pointer;
        }
        .floor-display-main-structure-diagram-choose-again-tip {
          width: 100%;
          height: 30px;
          line-height: 30px;
          color: white;
          background-color: #989796;
          cursor: pointer;
          position: absolute;
          left: 0;
          bottom: 0;
        }

        .floor-display-main-structure-diagram-choose-box {
          width: 100%;
          height: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          cursor: pointer;
          color: #999999;
          .el-icon-plus {
            font-size: 42px;
            margin-bottom: 20px;
          }
          .floor-display-main-structure-diagram-choose-tip {
            font-size: 16px;
          }
        }
      }
    }
    .floor-display-info {
      flex: 1;
      margin-left: 60px;
      border: 1px solid #DFE2E9;
      .el-tag {
        color: #FFFFFF;
      }
      .floor-display-info-item {
        height: 52px;
        line-height: 52px;
        font-size: 14px;
        border-bottom: 1px solid #DFE2E9;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        .floor-display-info-item-title {
          width: 115px;
          background: #EDF1F5;
        }
        .floor-display-info-item-main {
          flex: 1;
        }
      }
      .floor-display-info-item:last-child {
        border-bottom: 0;
      }
    }
  }
}
.housing-popover-box {
  margin-top: 0!important;
  padding: 0!important;
  width: 195px;
  height: 25px;
  background: rgba(137, 144, 143, 1) !important;
  border: 0!important;
  border-radius: 0px 0px 7px 7px!important;
  box-shadow: 0px 3px 8px rgba(137, 144, 143, 1)!important;
  .building-right-room-item-operation {
    height: 25px;
    padding: 0 47px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .building-right-room-item-operation-bg-box {
      width: 20px;
      height: 20px;
      line-height: 20px;
      cursor: pointer;
      background: #FFFFFF;
      border-radius: 50%;
      text-align: center;
      i {
        line-height: 20px;
        color: #000000;
        font-size: 16px;
      }
    }
  }
}

.building-right-room-proportion-popover-box {
  .building-right-room-proportion-popover-name {
    font-size: 15px;
    font-weight: 600;
    line-height: 21px;
    color: #333333;
    margin-bottom: 5px;
    .building-right-room-proportion-popover-name-tip {
      font-size: 12px;
      padding: 2px 7px;
      border-radius: 7px;
    }
  }
  .building-right-room-proportion-popover-info {
    font-size: 13px;
    font-weight: 400;
    line-height: 20px;
    color: #9F9FA8;
  }
  .building-right-room-proportion-popover-btn-line {
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      cursor: pointer;
      margin: 10px 12px 0 12px;
      color: #000000;
      font-size: 18px;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/view/ResourceCenter/HousingManagement/HousingManagement.vue